export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export enum AccessCategory {
  All = 'All',
  Biome = 'Biome',
  None = 'None',
}

export enum Action {
  Create = 'Create',
  Delete = 'Delete',
  Download = 'Download',
  Everything = 'Everything',
  ProvisionUsers = 'ProvisionUsers',
  Read = 'Read',
  ReadAllTenantPresentations = 'ReadAllTenantPresentations',
  ReadInternalRoles = 'ReadInternalRoles',
  SendToWorkflow = 'SendToWorkflow',
  SwitchUsers = 'SwitchUsers',
  Update = 'Update',
}

export type AdminPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type AggregateBeat = {
  __typename?: 'AggregateBeat';
  actionTaken?: Maybe<Scalars['Boolean']['output']>;
  actionable?: Maybe<Scalars['Boolean']['output']>;
  beats: Array<Beat>;
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  children?: Maybe<Array<AggregateBeat>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  matchRate?: Maybe<Scalars['Float']['output']>;
  month: Month;
  parent?: Maybe<AggregateBeat>;
  state: BeatState;
  triggerJiraReleaseTicket?: Maybe<Scalars['Boolean']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export enum AggregationRollupMode {
  Gated = 'Gated',
  Rolling = 'Rolling',
}

export type ApplicationNotice = {
  __typename?: 'ApplicationNotice';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  downtime?: Maybe<Scalars['Boolean']['output']>;
  downtimeDescription?: Maybe<Scalars['String']['output']>;
  downtimeEnd?: Maybe<Scalars['DateTime']['output']>;
  downtimeName?: Maybe<Scalars['String']['output']>;
  downtimeStart?: Maybe<Scalars['DateTime']['output']>;
  downtimeTitle?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
  tenants?: Maybe<Array<Tenant>>;
  title: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type AscendOutput = {
  __typename?: 'AscendOutput';
  componentId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataflowRun: DataflowRun;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalLocation: AscendOutputLocation;
  state: AscendOutputState;
  storedLocation: AscendOutputLocation;
  type: AscendOutputType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export type AscendOutputLocation = {
  __typename?: 'AscendOutputLocation';
  location?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum AscendOutputState {
  Done = 'Done',
  Error = 'Error',
  Pending = 'Pending',
}

export enum AscendOutputType {
  DataFeed = 'DataFeed',
  PseudoWriteTransform = 'PseudoWriteTransform',
  WriteConnector = 'WriteConnector',
}

export enum AuditourCategory {
  PostEtl = 'PostETL',
  PreEtl = 'PreETL',
  Raw = 'Raw',
}

export type AuditourReport = {
  __typename?: 'AuditourReport';
  category: AuditourCategory;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataflowRequest: DataflowRequest;
  dataflowRequestId: Scalars['String']['output'];
  dataflowRun: DataflowRun;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oePipelineRun: OePipelineRun;
  oePipelineRunId: Scalars['String']['output'];
  reportId?: Maybe<Scalars['Int']['output']>;
  state: ValidationStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export type Beat = {
  __typename?: 'Beat';
  actionTaken?: Maybe<Scalars['Boolean']['output']>;
  actionable?: Maybe<Scalars['Boolean']['output']>;
  aggregateBeats?: Maybe<Array<AggregateBeat>>;
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  datasetInstances: Array<DatasetInstance>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineEvents?: Maybe<Array<LifelineEvent>>;
  month: Month;
  requestedDate?: Maybe<Scalars['DateTime']['output']>;
  requiresCrosswalk?: Maybe<Scalars['Boolean']['output']>;
  state: BeatState;
  submissions?: Maybe<Array<Submission>>;
  triggerJiraReleaseTicket?: Maybe<Scalars['Boolean']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export enum BeatState {
  Complete = 'COMPLETE',
  Inprogress = 'INPROGRESS',
  Unfilled = 'UNFILLED',
}

export enum BiomeUserRegion {
  Pk = 'PK',
  Us = 'US',
}

export type Bookmark = {
  __typename?: 'Bookmark';
  category: BookmarkCategory;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  /** Description of the bookmark */
  description?: Maybe<Scalars['String']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  url: Scalars['String']['output'];
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
};

export enum BookmarkCategory {
  Dashboard = 'DASHBOARD',
  Homepage = 'HOMEPAGE',
}

export enum CardinalityType {
  OneToN = 'OneToN',
  OneToOne = 'OneToOne',
  ZeroToN = 'ZeroToN',
  ZeroToOne = 'ZeroToOne',
  ZeroToZero = 'ZeroToZero',
}

export type CareEntity = {
  __typename?: 'CareEntity';
  active: Scalars['Boolean']['output'];
  aggregateBeats: Array<AggregateBeat>;
  aggregated: Scalars['Boolean']['output'];
  alternateNames?: Maybe<Array<Scalars['String']['output']>>;
  anonymousCode?: Maybe<Scalars['String']['output']>;
  /** Archived DSMs this care entity participates in, which `diseaseStateModules` leaves out. */
  archivedDiseaseStateModules: Array<DiseaseStateModule>;
  beats: Array<Beat>;
  business?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<CareEntity>>;
  city?: Maybe<Scalars['String']['output']>;
  cmsId?: Maybe<Scalars['String']['output']>;
  cmsIdNotAvailable: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataframes: Array<DataFrame>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  diseaseStateModules: Array<DiseaseStateModule>;
  echoFollowupOptions: Array<EchoFindingFollowupOption>;
  excludedDsms: Array<DiseaseStateModule>;
  id: Scalars['ID']['output'];
  ids?: Maybe<Array<Scalars['String']['output']>>;
  includeInBenchmarks: Scalars['Boolean']['output'];
  invoiceMonth?: Maybe<Scalars['Int']['output']>;
  isEngagementEntity: Scalars['Boolean']['output'];
  /** Per-member DSM scoping for this aggregate. A member absent from this list contributes all of its own DSMs. On the parent because a care entity can have several parents, so the value is undefined without knowing which parent is asking. */
  memberDsms: Array<CareEntityMemberDsm>;
  monthlySponsorTouchbase: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  noOfBeds?: Maybe<Scalars['Int']['output']>;
  onboardingCompletedOn?: Maybe<Scalars['DateTime']['output']>;
  parents?: Maybe<Array<CareEntity>>;
  physicianChampion?: Maybe<Scalars['String']['output']>;
  projectSponsor?: Maybe<Scalars['String']['output']>;
  pushOnlyDsms: Array<DiseaseStateModule>;
  reasonForNoCmsId?: Maybe<Scalars['String']['output']>;
  reviewDsms: Array<DiseaseStateModule>;
  roles?: Maybe<Array<Role>>;
  shortDisplayName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  submissions: Array<Submission>;
  supportedApps?: Maybe<Array<SupportedApps>>;
  teaching: Scalars['Boolean']['output'];
  tenants: Array<Tenant>;
  type: CareEntityType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  usGeoRegion?: Maybe<UsGeoRegion>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CareEntityDsmPair = {
  __typename?: 'CareEntityDsmPair';
  careEntityId: Scalars['ID']['output'];
  dsmId: Scalars['Int']['output'];
};

export type CareEntityMemberDsm = {
  __typename?: 'CareEntityMemberDsm';
  childId: Scalars['ID']['output'];
  diseaseStateModules: Array<DiseaseStateModule>;
};

export type CareEntityMemberDsmInput = {
  childId: Scalars['ID']['input'];
  /** An empty array unscopes the edge: it then participates for all of the child's DSMs. */
  diseaseStateModules: Array<UpdateDiseaseStateModuleInput>;
};

export enum CareEntityType {
  Campus = 'Campus',
  Clinic = 'Clinic',
  Hospital = 'Hospital',
  Region = 'Region',
  System = 'System',
}

export type CareEntityUpdateImpact = {
  __typename?: 'CareEntityUpdateImpact';
  childrenAdditionImpact?: Maybe<Array<Scalars['String']['output']>>;
  childrenRemovalImpact?: Maybe<Array<Role>>;
  dsmAdditionImpact?: Maybe<DsmAdditionImpact>;
  dsmRemovalImpact?: Maybe<DsmRemovalImpact>;
  memberDsmImpact?: Maybe<Array<Scalars['String']['output']>>;
  usersImpacted?: Maybe<Array<User>>;
};

export type CasePolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type CathAudit = {
  __typename?: 'CathAudit';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  auditFlagSource?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeETLVersion?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  diagnosisPOACodeList?: Maybe<Scalars['String']['output']>;
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  dischargeQuarter?: Maybe<Scalars['String']['output']>;
  dischargeYear?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['String']['output']>;
  etlRefresh?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<FlagType>;
  hospital?: Maybe<Scalars['String']['output']>;
  icd10TriggerCode?: Maybe<Scalars['String']['output']>;
  keyField?: Maybe<Scalars['String']['output']>;
  keyFieldValue?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mrnOriginal?: Maybe<Scalars['String']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciStatus?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  reviewTriggerDescription?: Maybe<Scalars['String']['output']>;
  riskReview?: Maybe<Scalars['String']['output']>;
  riskValue?: Maybe<Scalars['String']['output']>;
  surgicalQuarter?: Maybe<Scalars['String']['output']>;
  surgicalYear?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails: Array<CathAuditTrail>;
  visitId?: Maybe<Scalars['Float']['output']>;
  visitTiming?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type CathAuditTrail = {
  __typename?: 'CathAuditTrail';
  auditTask?: Maybe<CathAudit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type Certificate = {
  __typename?: 'Certificate';
  active: Scalars['Boolean']['output'];
  certificateString?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identityProvider?: Maybe<IdentityProvider>;
  identityProviderId: Scalars['String']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  signatureAlgorithm?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']['output']>;
  validityNotAfter?: Maybe<Scalars['DateTime']['output']>;
  validityNotBefore?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CheckApplicationNoticeConflictInput = {
  endTime: Scalars['DateTime']['input'];
  excludeId?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['DateTime']['input'];
};

export type ClientDataFile = {
  __typename?: 'ClientDataFile';
  blobUrl?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<ClientDataFile>>;
  clientDataFileFamily?: Maybe<ClientDataFileFamily>;
  clientDataFileFamilyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataframes?: Maybe<Array<DataFrame>>;
  deletedAt: Scalars['DateTime']['output'];
  extensionType: ExtensionType;
  id: Scalars['ID']['output'];
  ingestedAt?: Maybe<Scalars['DateTime']['output']>;
  ingestionFileId?: Maybe<Scalars['Float']['output']>;
  ingestionState: IngestionState;
  isProcessed: Scalars['Boolean']['output'];
  jiraIssueId?: Maybe<Scalars['String']['output']>;
  jiraIssues?: Maybe<Array<JiraIssue>>;
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineActionErrors?: Maybe<Array<LifelineActionError>>;
  lifelineEvents: Array<LifelineEvent>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ClientDataFile>;
  parentId?: Maybe<Scalars['String']['output']>;
  rootTriggerId?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  submissions: Submission;
  submittedAt: Scalars['DateTime']['output'];
  submittedBy?: Maybe<User>;
  submittedById?: Maybe<Scalars['String']['output']>;
  supersedesId?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails?: Maybe<Array<ClientDataFileTrail>>;
  triggerId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ClientDataFileFamily = {
  __typename?: 'ClientDataFileFamily';
  clientDataFiles: Array<ClientDataFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt: Scalars['DateTime']['output'];
  expectedCount: Scalars['Float']['output'];
  expectedFiles?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineEvents?: Maybe<Array<LifelineEvent>>;
  rootTriggerId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export enum ClientDataFileState {
  ClientFollowupInitiated = 'ClientFollowupInitiated',
  ClientFollowupRequired = 'ClientFollowupRequired',
  FileAssessmentRequired = 'FileAssessmentRequired',
  FurtherDataOpsRequired = 'FurtherDataOpsRequired',
  Ignore = 'Ignore',
  InvestigationRequired = 'InvestigationRequired',
  New = 'New',
  OnHold = 'OnHold',
  Planned = 'Planned',
  ReviewRequired = 'ReviewRequired',
}

export type ClientDataFileTrail = {
  __typename?: 'ClientDataFileTrail';
  clientDataFile: ClientDataFile;
  clientDataFileId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  jiraRelease?: Maybe<Scalars['String']['output']>;
  noticeSentDate?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<ClientDataFileState>;
  supportEmail?: Maybe<SupportEmail>;
  supportEmailId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ClinicalProgram = {
  __typename?: 'ClinicalProgram';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  id: Scalars['Int']['output'];
  isAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ClinicianPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type Comment = {
  __typename?: 'Comment';
  children: Array<Comment>;
  /** The comment content */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  /** Mark comment as internal/private (internal) or everyone (public) */
  internal: Scalars['Boolean']['output'];
  /** Track if comment was edited */
  isEdited: Scalars['Boolean']['output'];
  /** True if parent comment was deleted but this comment was preserved */
  isOrphaned: Scalars['Boolean']['output'];
  parent?: Maybe<Comment>;
  /** Parent comment ID for nested replies */
  parentId?: Maybe<Scalars['String']['output']>;
  reactions: Array<CommentReaction>;
  reactionsCount?: Maybe<Scalars['Int']['output']>;
  repliesCount?: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  thread: Thread;
  /** Thread ID this comment belongs to */
  threadId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

export type CommentReaction = {
  __typename?: 'CommentReaction';
  comment: Comment;
  commentId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  /** Type of reaction (emoji) */
  reactionType: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

export type CreateApplicationNoticeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  downtime?: InputMaybe<Scalars['Boolean']['input']>;
  downtimeDescription?: InputMaybe<Scalars['String']['input']>;
  downtimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  downtimeName?: InputMaybe<Scalars['String']['input']>;
  downtimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  downtimeTitle?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  title: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateBookmarkInput = {
  category: BookmarkCategory;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  url: Scalars['String']['input'];
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type CreateBulkCareEntityInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aggregated?: InputMaybe<Scalars['Boolean']['input']>;
  alternateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  anonymousCode?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  cmsIdNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceMonth?: InputMaybe<Scalars['Int']['input']>;
  isEngagementEntity?: InputMaybe<Scalars['Boolean']['input']>;
  monthlySponsorTouchbase?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noOfBeds?: InputMaybe<Scalars['Int']['input']>;
  onboardingCompletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  parents?: InputMaybe<Array<UpdateCareEntityInput>>;
  physicianChampion?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<Scalars['String']['input']>;
  reasonForNoCmsId?: InputMaybe<Scalars['String']['input']>;
  shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  teaching?: InputMaybe<Scalars['Boolean']['input']>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  type?: InputMaybe<CareEntityType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usGeoRegion?: InputMaybe<UsGeoRegion>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCareEntityInput = {
  active: Scalars['Boolean']['input'];
  aggregated: Scalars['Boolean']['input'];
  alternateNames: Array<Scalars['String']['input']>;
  anonymousCode?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<UpdateCareEntityInput>>;
  city?: InputMaybe<Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  cmsIdNotAvailable: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  datasets?: InputMaybe<Array<UpdateDatasetInput>>;
  description: Scalars['String']['input'];
  diseaseStateModules?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  /** DSMs this care entity participates in but neither reviews nor pushes. Absent leaves existing exclusions untouched; empty clears them; present is authoritative. */
  excludedDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInBenchmarks: Scalars['Boolean']['input'];
  invoiceMonth?: InputMaybe<Scalars['Int']['input']>;
  isEngagementEntity?: InputMaybe<Scalars['Boolean']['input']>;
  monthlySponsorTouchbase?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  noOfBeds?: InputMaybe<Scalars['Int']['input']>;
  onboardingCompletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  parents?: InputMaybe<Array<UpdateCareEntityInput>>;
  physicianChampion?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<Scalars['String']['input']>;
  pushOnlyDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  reasonForNoCmsId?: InputMaybe<Scalars['String']['input']>;
  reviewDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<Array<SubmissionInput>>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  teaching: Scalars['Boolean']['input'];
  tenants: Array<UpdateTenantInput>;
  type: CareEntityType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usGeoRegion?: InputMaybe<UsGeoRegion>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDefinitionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  definition?: InputMaybe<Scalars['String']['input']>;
  element: UpdateElementInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateDictionaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataFeed?: InputMaybe<CreateDictionaryInput>;
  dataset: UpdateDatasetInput;
  feedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sections?: InputMaybe<Array<CreateSectionInput>>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  type: DictionaryType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version: Scalars['String']['input'];
};

export type CreateDiseaseStateModuleInput = {
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  clinicalProgram: UpdateClinicalProgramInput;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  criticalDatasets?: InputMaybe<Array<UpdateDatasetInput>>;
  datasets?: InputMaybe<Array<UpdateDatasetInput>>;
  description: Scalars['String']['input'];
  hideRiskAuditCharts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  multiProcTables?: InputMaybe<Array<DiseaseStateModuleMultiProcTableInput>>;
  name: Scalars['String']['input'];
  riskMetrics?: InputMaybe<Array<DiseaseStateModuleRiskMetricInput>>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateElementInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeSystemName?: InputMaybe<Scalars['String']['input']>;
  codingInstructions?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  createdBy?: InputMaybe<UpdateUserInput>;
  dataSource?: InputMaybe<ElementDataSourceType>;
  dataType?: InputMaybe<ElementDataType>;
  dbDataType?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<CreateDefinitionInput>;
  elementReference: Scalars['String']['input'];
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBaseElement: Scalars['Boolean']['input'];
  isDynamicList?: InputMaybe<Scalars['Boolean']['input']>;
  isFollowupElement: Scalars['Boolean']['input'];
  isHarvested?: InputMaybe<Scalars['Boolean']['input']>;
  isIdentifier: Scalars['Boolean']['input'];
  missingData?: InputMaybe<ElementMissingDataAction>;
  name: Scalars['String']['input'];
  parentChildValidations?: InputMaybe<Array<CreateParentChildValidationInput>>;
  phi?: InputMaybe<Scalars['Boolean']['input']>;
  precision?: InputMaybe<Scalars['String']['input']>;
  ranges?: InputMaybe<Array<CreateRangeInput>>;
  role?: InputMaybe<Scalars['String']['input']>;
  section: UpdateSectionInput;
  sectionId: Scalars['String']['input'];
  selectionType?: InputMaybe<ElementSelectionType>;
  selections?: InputMaybe<Array<CreateSelectionInput>>;
  shortName: Scalars['String']['input'];
  targetValue?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  updateAt: Scalars['DateTime']['input'];
  updateBy?: InputMaybe<UpdateUserInput>;
  vendorInstruction?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMeasureTableauViewInput = {
  isPrimary: Scalars['Boolean']['input'];
  tableauViewId: Scalars['Int']['input'];
};

export type CreateNestedDimensionSetInput = {
  dimensions?: InputMaybe<Array<UpdateDimensionInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  measure?: InputMaybe<UpdateMeasureMetadataInput>;
};

export type CreateObjectMeasureInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<MeasureLinkType>;
  objectMeasure?: InputMaybe<UpdateMeasureMetadataInput>;
  processMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  subjectMeasure?: InputMaybe<UpdateMeasureMetadataInput>;
};

export type CreateParentChildValidationInput = {
  createdAt: Scalars['DateTime']['input'];
  createdBy?: InputMaybe<UpdateUserInput>;
  element: UpdateElementInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  parent: UpdateElementInput;
  parentElementReference: Scalars['String']['input'];
  parentElementSelectionName: Scalars['String']['input'];
  parentSelection: UpdateSelectionInput;
  updateAt: Scalars['DateTime']['input'];
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateRangeInput = {
  createdAt: Scalars['DateTime']['input'];
  createdBy?: InputMaybe<UpdateUserInput>;
  element: UpdateElementInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  updateAt: Scalars['DateTime']['input'];
  updateBy?: InputMaybe<UpdateUserInput>;
  usualRangeMax?: InputMaybe<Scalars['Float']['input']>;
  usualRangeMin?: InputMaybe<Scalars['Float']['input']>;
  validRangeMax?: InputMaybe<Scalars['Float']['input']>;
  validRangeMin?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateRoleInput = {
  code: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  tenant: UpdateTenantInput;
  type: RoleType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type CreateSectionInput = {
  cardinality: CardinalityType;
  containerClass?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dictionary?: InputMaybe<UpdateDictionaryInput>;
  elements?: InputMaybe<Array<CreateElementInput>>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parent?: InputMaybe<SectionInput>;
  parentSection?: InputMaybe<Scalars['String']['input']>;
  sectionCode: Scalars['String']['input'];
  sectionDisplayName: Scalars['String']['input'];
  sectionType: SectionType;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateSelectionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeSystemName?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['DateTime']['input'];
  createdBy?: InputMaybe<UpdateUserInput>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  element: UpdateElementInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  selectionDefinition?: InputMaybe<Scalars['String']['input']>;
  selectionName: Scalars['String']['input'];
  updateAt: Scalars['DateTime']['input'];
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateSubjectMeasureInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<MeasureLinkType>;
  objectMeasure?: InputMaybe<UpdateMeasureMetadataInput>;
  processMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  subjectMeasure?: InputMaybe<UpdateMeasureMetadataInput>;
};

export type CreateUrlMapInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  destination: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  method: RequestMethod;
  responseType: ResponseType;
  source: Scalars['String']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type CreateUserInput = {
  adGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  careEntityCode?: InputMaybe<Scalars['String']['input']>;
  ccOnboardingEmail?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<CreateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableBiomedataLogin?: InputMaybe<Scalars['Boolean']['input']>;
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  email: Scalars['String']['input'];
  enableSftp?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time when the user was enabled. This is used to keep certain items on the UI disabled until this change is synced to Azure AD. */
  enabledTime?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  homepage?: InputMaybe<CreateBookmarkInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName: Scalars['String']['input'];
  notifications?: InputMaybe<Array<UpdateNotificationInput>>;
  organizationalUnit?: InputMaybe<Scalars['String']['input']>;
  otherEmails?: InputMaybe<Array<OtherEmailInput>>;
  passwordNeverExpires?: InputMaybe<Scalars['Boolean']['input']>;
  permanentAccount?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UpdateRoleInput>>;
  root?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<UserStatus>;
  submitsData?: InputMaybe<Scalars['Boolean']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantPolicies?: InputMaybe<Array<TenantPolicyInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  twoFactor?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<CreateUserInput>;
  /** Unique username */
  username: Scalars['String']['input'];
};

export enum CrosswalkState {
  CompletedWithWarnings = 'COMPLETED_WITH_WARNINGS',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  ManualOverride = 'MANUAL_OVERRIDE',
  NotRequired = 'NOT_REQUIRED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export enum DagsterTrigger {
  MoveToProd = 'MoveToProd',
}

export enum DagsterTriggerPipelineType {
  CaseLists = 'CaseLists',
  EchoNlp = 'EchoNLP',
  Mcl = 'MCL',
  Measures = 'Measures',
  Oe = 'OE',
  Pm = 'PM',
  RiskAudits = 'RiskAudits',
  Unmasker = 'Unmasker',
  VisitLevelFields = 'VisitLevelFields',
}

export type DashboardPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  workbookGroupId: Scalars['String']['input'];
  workbookId: Scalars['String']['input'];
};

export type DataFrame = {
  __typename?: 'DataFrame';
  auditorId?: Maybe<Scalars['String']['output']>;
  availableToETL: EtlAvailability;
  careEntities?: Maybe<Array<CareEntity>>;
  clientDataFile?: Maybe<ClientDataFile>;
  clientDataFileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  crosswalkApplicationState?: Maybe<CrosswalkState>;
  crosswalkAppliedPercentage?: Maybe<Scalars['Float']['output']>;
  crosswalkLoadState?: Maybe<CrosswalkState>;
  crosswalkLoadedPercentage?: Maybe<Scalars['Float']['output']>;
  crosswalkLocation?: Maybe<Scalars['String']['output']>;
  dataframeMclChunks?: Maybe<Array<DataframeMclChunk>>;
  dataset?: Maybe<Dataset>;
  datasetId?: Maybe<Scalars['Int']['output']>;
  datasetInstances: Array<DatasetInstance>;
  deletedAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineEvents: Array<LifelineEvent>;
  location: Scalars['String']['output'];
  maskAt?: Maybe<Scalars['DateTime']['output']>;
  maskDataFrameName?: Maybe<Scalars['String']['output']>;
  maskLocation?: Maybe<Scalars['String']['output']>;
  maskState: MaskState;
  maskedAt?: Maybe<Scalars['DateTime']['output']>;
  maskedDataFrameLocation?: Maybe<Scalars['String']['output']>;
  maskedDataFrameName?: Maybe<Scalars['String']['output']>;
  maskedLocations?: Maybe<Array<MaskedDataframeLocations>>;
  maskerState: MaskerState;
  mclStatus: DataframeMclStatus;
  name: Scalars['String']['output'];
  phiEnrichedLocation?: Maybe<Scalars['String']['output']>;
  phiEnrichmentState: PhiEnrichmentState;
  redactedAt?: Maybe<Scalars['DateTime']['output']>;
  redactorState: MaskerState;
  registrySubsetName?: Maybe<Scalars['String']['output']>;
  rowCount: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  subsetId?: Maybe<Scalars['Float']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails?: Maybe<Array<DataframeTrail>>;
  unknownCareEntities?: Maybe<Array<Scalars['String']['output']>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  validation: DataframeValidationStatus;
};

export enum DataPlatform {
  AscendGen1 = 'AscendGen1',
  AscendGen3 = 'AscendGen3',
  Dagster = 'Dagster',
}

export type Dataflow = {
  __typename?: 'Dataflow';
  components?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataFeedInputs?: Maybe<Array<Scalars['String']['output']>>;
  dataFeedOutputs?: Maybe<Array<Scalars['String']['output']>>;
  dataServiceName?: Maybe<Scalars['String']['output']>;
  datafeedTransforms?: Maybe<Array<Scalars['String']['output']>>;
  dataflowRuns: Array<DataflowRun>;
  deployment?: Maybe<Scalars['String']['output']>;
  diseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  platform: DataPlatform;
  project?: Maybe<Scalars['String']['output']>;
  pseudoWriteTransforms?: Maybe<Array<Scalars['String']['output']>>;
  readConnectors?: Maybe<Array<Scalars['String']['output']>>;
  requests: Array<DataflowRequest>;
  type: DataflowType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  writeConnectors?: Maybe<Array<Scalars['String']['output']>>;
};

export type DataflowRequest = {
  __typename?: 'DataflowRequest';
  auditourReports: Array<AuditourReport>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataflow?: Maybe<Dataflow>;
  dataflowRun?: Maybe<DataflowRun>;
  id: Scalars['String']['output'];
  selectedDsms?: Maybe<Array<DiseaseStateModule>>;
  status: DataflowRequestStatus;
  tenant?: Maybe<Tenant>;
  triggerablePipeline?: Maybe<TriggerablePipeline>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export enum DataflowRequestStatus {
  AuditourFailed = 'AuditourFailed',
  AuditourInProgress = 'AuditourInProgress',
  Completed = 'Completed',
  Error = 'Error',
  Pending = 'Pending',
  PipelineInProgress = 'PipelineInProgress',
}

export type DataflowRun = {
  __typename?: 'DataflowRun';
  allowExpiration: Scalars['Boolean']['output'];
  auditourReports: Array<AuditourReport>;
  codeVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataFrames: Array<DataflowRunDataFrame>;
  dataflow: Dataflow;
  dataflowId: Scalars['String']['output'];
  dataflowRunUUID?: Maybe<Scalars['String']['output']>;
  datasetInstances?: Maybe<Array<DatasetInstance>>;
  deployment?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  etlRiskAudits: Array<DataflowRun>;
  id: Scalars['String']['output'];
  inputFilesListed?: Maybe<Scalars['Int']['output']>;
  inputFilesMatched?: Maybe<Scalars['Int']['output']>;
  inputFilesUnidentified?: Maybe<Scalars['Int']['output']>;
  inputRuns: Array<DataflowRunInputRun>;
  inputTracking: InputTrackingStatus;
  inputTrackingAt?: Maybe<Scalars['DateTime']['output']>;
  inputTrackingError?: Maybe<Scalars['JSON']['output']>;
  milestones: Array<DataflowRunMilestone>;
  movedToProd: MovedToProdStatus;
  movedToProdAt?: Maybe<Scalars['DateTime']['output']>;
  oePipelineRuns: Array<OePipelineRun>;
  outputs: Array<AscendOutput>;
  path: Scalars['String']['output'];
  release?: Maybe<Scalars['String']['output']>;
  request?: Maybe<DataflowRequest>;
  requestId?: Maybe<Scalars['String']['output']>;
  riskAuditInput?: Maybe<DataflowRun>;
  riskAuditInputId?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: DataflowRunStatus;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  unidentifiedInputs: Array<DataflowRunUnidentifiedInput>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  validation: DataflowValidationStatus;
};

export type DataflowRunDataFrame = {
  __typename?: 'DataflowRunDataFrame';
  createdAt: Scalars['DateTime']['output'];
  dataFrame: DataFrame;
  dataFrameId: Scalars['String']['output'];
  dataflowRun?: Maybe<DataflowRun>;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sourceName: Scalars['String']['output'];
};

export enum DataflowRunInputResolvedVia {
  MovedToProdQuery = 'MovedToProdQuery',
  PromotedRunstats = 'PromotedRunstats',
  Unresolved = 'Unresolved',
}

export enum DataflowRunInputRole {
  Admin = 'Admin',
  MeasuresOutput = 'MeasuresOutput',
}

export type DataflowRunInputRun = {
  __typename?: 'DataflowRunInputRun';
  createdAt: Scalars['DateTime']['output'];
  dataflowRun?: Maybe<DataflowRun>;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputDataflowRun?: Maybe<DataflowRun>;
  inputDataflowRunId?: Maybe<Scalars['String']['output']>;
  inputRunUUID?: Maybe<Scalars['String']['output']>;
  inputTenant?: Maybe<Tenant>;
  inputTenantId: Scalars['String']['output'];
  leaves?: Maybe<Array<Scalars['String']['output']>>;
  promotedPath: Scalars['String']['output'];
  registry: Scalars['String']['output'];
  resolvedVia: DataflowRunInputResolvedVia;
  role: DataflowRunInputRole;
};

export type DataflowRunMilestone = {
  __typename?: 'DataflowRunMilestone';
  adlsPath?: Maybe<Scalars['String']['output']>;
  assetKey: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataflowRun: DataflowRun;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materializationId?: Maybe<Scalars['Int']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  sinkTable: Scalars['String']['output'];
};

export enum DataflowRunStatus {
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  Error = 'Error',
  InProgress = 'InProgress',
  Incomplete = 'Incomplete',
}

export type DataflowRunUnidentifiedInput = {
  __typename?: 'DataflowRunUnidentifiedInput';
  containerPath: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataflowRun?: Maybe<DataflowRun>;
  dataflowRunId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sourceName: Scalars['String']['output'];
  unidentifiedCount: Scalars['Int']['output'];
  unidentifiedNames: Array<Scalars['String']['output']>;
};

export enum DataflowType {
  CaseLists = 'CaseLists',
  EchoNlp = 'EchoNLP',
  Mcl = 'MCL',
  Measures = 'Measures',
  Oe = 'OE',
  Pm = 'PM',
  Risk = 'Risk',
  Unmasker = 'Unmasker',
  VisitLevelFields = 'VisitLevelFields',
}

export enum DataflowValidationStatus {
  Failed = 'Failed',
  ManualOverride = 'ManualOverride',
  Pending = 'Pending',
  Success = 'Success',
}

export enum DataframeLocationType {
  Adl = 'ADL',
  MySql = 'MySQL',
  Parquet = 'Parquet',
  ParquetLocation = 'ParquetLocation',
}

/** Dataframe Chunks that have been loaded in mcl */
export type DataframeMclChunk = {
  __typename?: 'DataframeMclChunk';
  casesAdded: Scalars['Float']['output'];
  chunkNumber: Scalars['Float']['output'];
  dataframe: DataFrame;
  dataframeId: Scalars['String']['output'];
  elapsedTime: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  rootTriggerId: Scalars['String']['output'];
};

export enum DataframeMclStatus {
  DataLoadedInMcl = 'DataLoadedInMcl',
  DataLoadedInMclWithWarnings = 'DataLoadedInMclWithWarnings',
  DataSubmittedToMcl = 'DataSubmittedToMcl',
  DataSubmittedToMclWithWarnings = 'DataSubmittedToMclWithWarnings',
  Failed = 'Failed',
  Inprogress = 'Inprogress',
  Pending = 'Pending',
}

export type DataframeTrail = {
  __typename?: 'DataframeTrail';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  dataframe: DataFrame;
  dataframeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export enum DataframeValidationStatus {
  Error = 'Error',
  Failed = 'Failed',
  ManualOverride = 'ManualOverride',
  Pending = 'Pending',
  Success = 'Success',
}

export type Dataset = {
  __typename?: 'Dataset';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  criticalDiseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  crosswalkRequired: Scalars['Boolean']['output'];
  datasetDictionaries?: Maybe<Array<Dictionary>>;
  datasetVersions?: Maybe<Array<DatasetVersion>>;
  deadlines?: Maybe<Array<Deadline>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  diseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  id: Scalars['Int']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isCrosswalkSource: Scalars['Boolean']['output'];
  /** Indicates if past submissions should be dropped from the data pipeline when new data for an overlapping time period is provided. If this is marked "yes" old data is removed and replaced entirely by the new submission */
  isDropAndLoad?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates that this dataset holds follow-up assessments for a registry rather than the base visit. Report Builder treats the one non-follow-up clinical dataset of a disease state module as the anchor: it is the dataset the care-entity and date filters apply to, and the only one carrying visitid. Follow-up datasets correlate to it on biomeencounterid. */
  isFollowUp: Scalars['Boolean']['output'];
  isRegistry: Scalars['Boolean']['output'];
  /** Indicates if submissions request should be sent on tenant-level or care-entity level. If this is marked "yes" submission-request will contain tenant-code otherwise it will contain care-entities list. */
  isTenantLevel?: Maybe<Scalars['Boolean']['output']>;
  managingSociety: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primaryDiseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  submissions?: Maybe<Array<Submission>>;
  /** Indicates if the dataset supports the report builder feature. */
  supportsReportBuilder?: Maybe<Scalars['Boolean']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type DatasetInstance = {
  __typename?: 'DatasetInstance';
  beats?: Maybe<Array<Beat>>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  caseCount?: Maybe<Scalars['Float']['output']>;
  coverage: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataflowRuns?: Maybe<Array<DataflowRun>>;
  dataframes?: Maybe<Array<DataFrame>>;
  dataset?: Maybe<Dataset>;
  datasetId?: Maybe<Scalars['Int']['output']>;
  enrichedCaseCount?: Maybe<Scalars['Float']['output']>;
  enrichedLocation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  isReady: Scalars['Boolean']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  lifelineEvents?: Maybe<Array<LifelineEvent>>;
  maskCaseCount?: Maybe<Scalars['Float']['output']>;
  maskLocation?: Maybe<Scalars['String']['output']>;
  maskedCaseCount?: Maybe<Scalars['Float']['output']>;
  maskedLocation?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Scalars['Float']['output']>;
  month: Month;
  pastYearMean?: Maybe<Scalars['Float']['output']>;
  pastYearStdDev?: Maybe<Scalars['Float']['output']>;
  rowCount?: Maybe<Scalars['Float']['output']>;
  submittedAt: Scalars['String']['output'];
  unmaskedCaseCount?: Maybe<Scalars['Float']['output']>;
  unmaskedLocation?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type DatasetVersion = {
  __typename?: 'DatasetVersion';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataset: Dataset;
  datasetId: Scalars['Int']['output'];
  datasetVersionFields?: Maybe<Array<DatasetVersionField>>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  versionNumber: Scalars['Float']['output'];
};

export type DatasetVersionField = {
  __typename?: 'DatasetVersionField';
  datasetVersion: DatasetVersion;
  datasetVersionId: Scalars['ID']['output'];
  fieldId: Scalars['Int']['output'];
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
};

export enum DateRangeTypes {
  CustomDateRange = 'CustomDateRange',
  CustomQuarters = 'CustomQuarters',
  Last3Months = 'Last3Months',
  Last4Quarters = 'Last4Quarters',
  LastMonth = 'LastMonth',
  LastQuarter = 'LastQuarter',
  LastWeek = 'LastWeek',
}

export type Deadline = {
  __typename?: 'Deadline';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataset: Dataset;
  datasetId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  monthIncluded?: Maybe<Scalars['String']['output']>;
  monthSubmissionDeadline?: Maybe<Scalars['DateTime']['output']>;
  quarterIncluded?: Maybe<Scalars['String']['output']>;
  quarterSubmissionDeadline?: Maybe<Scalars['DateTime']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type Definition = {
  __typename?: 'Definition';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  definition: Scalars['String']['output'];
  element: Element;
  id: Scalars['ID']['output'];
  source?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

export type DevelopmentDimension = {
  __typename?: 'DevelopmentDimension';
  active: Scalars['Boolean']['output'];
  aeQualifying: Scalars['Boolean']['output'];
  allMeasures: Scalars['Boolean']['output'];
  class: Scalars['String']['output'];
  codeVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensionId: Scalars['Int']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  documentation?: Maybe<Scalars['JSON']['output']>;
  excludeValues?: Maybe<Array<Scalars['String']['output']>>;
  fieldName: Scalars['String']['output'];
  hideFromReports: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isGlobal: Scalars['Boolean']['output'];
  jiraLink?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  multiProcTable?: Maybe<MultiProcTable>;
  multiProcTableId?: Maybe<Scalars['String']['output']>;
  oeQualifying: Scalars['Boolean']['output'];
  pipelineElement?: Maybe<PipelineElement>;
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  sourceContinuousField?: Maybe<Scalars['String']['output']>;
  state: EntityState;
  stateHistory?: Maybe<Scalars['JSON']['output']>;
  status: EntityStatus;
  type: DimensionType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  valueMap?: Maybe<Scalars['JSON']['output']>;
};

export type DevelopmentMeasure = {
  __typename?: 'DevelopmentMeasure';
  accessCategory: AccessCategory;
  active: Scalars['Boolean']['output'];
  adjustment?: Maybe<Array<Scalars['String']['output']>>;
  aggregationFn?: Maybe<Array<Scalars['String']['output']>>;
  aggregationType?: Maybe<SummaryCalculationType>;
  annualMeasureBaseId?: Maybe<Scalars['String']['output']>;
  benchmarkExtraction: Scalars['Boolean']['output'];
  codeVersion?: Maybe<Scalars['String']['output']>;
  commonMeasureDisplayName: Scalars['String']['output'];
  commonMeasureQualifying?: Maybe<Scalars['Boolean']['output']>;
  costComponentMeasure?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  dataTypeRequired?: Maybe<MeasureInputDataType>;
  denominatorColumnName?: Maybe<Scalars['String']['output']>;
  denominatorDocumentation?: Maybe<Scalars['JSON']['output']>;
  denominatorLegacyDescription?: Maybe<Scalars['String']['output']>;
  denominatorPipelineElement?: Maybe<PipelineElement>;
  denominatorPipelineElementId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developedOn?: Maybe<Scalars['DateTime']['output']>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  excludedCohortIds?: Maybe<Array<Scalars['Float']['output']>>;
  hideFromReports: Scalars['Boolean']['output'];
  higherIsBetter?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  includeColumnName?: Maybe<Scalars['String']['output']>;
  includeDocumentation?: Maybe<Scalars['JSON']['output']>;
  includePipelineElement?: Maybe<PipelineElement>;
  includePipelineElementId?: Maybe<Scalars['String']['output']>;
  isBenchmark?: Maybe<Scalars['Boolean']['output']>;
  jiraLink?: Maybe<Scalars['String']['output']>;
  losROIQualifying?: Maybe<Scalars['Boolean']['output']>;
  measureId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ncdrMeasureName?: Maybe<Scalars['String']['output']>;
  numeratorColumnName?: Maybe<Scalars['String']['output']>;
  numeratorDocumentation?: Maybe<Scalars['JSON']['output']>;
  numeratorLegacyDescription?: Maybe<Scalars['String']['output']>;
  numeratorPipelineElement?: Maybe<PipelineElement>;
  numeratorPipelineElementId?: Maybe<Scalars['String']['output']>;
  numeratorUnit: Scalars['String']['output'];
  opportunityType: Array<OpportunityType>;
  outcomeType?: Maybe<MeasureOutcomeType>;
  parentId?: Maybe<Scalars['Int']['output']>;
  publicationSource?: Maybe<Array<PublicationSource>>;
  rareEvent: Scalars['Boolean']['output'];
  registryMeasureId?: Maybe<Scalars['Int']['output']>;
  reportRowId?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  riskAdjusted: Scalars['Boolean']['output'];
  riskMetric?: Maybe<RiskMetric>;
  riskMetricDocumentation?: Maybe<Scalars['JSON']['output']>;
  riskMetricId?: Maybe<Scalars['String']['output']>;
  riskMetricPipelineElement?: Maybe<PipelineElement>;
  riskMetricPipelineElementId?: Maybe<Scalars['String']['output']>;
  roiCalcType?: Maybe<SummaryCalculationType>;
  state: EntityState;
  stateHistory?: Maybe<Scalars['JSON']['output']>;
  status: EntityStatus;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  summaryInitiativeMeasure: Scalars['Boolean']['output'];
  tableName?: Maybe<Scalars['String']['output']>;
  testCapture?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  validationSource?: Maybe<Scalars['String']['output']>;
  volumeMeasure?: Maybe<Scalars['Boolean']['output']>;
};

export type Dictionary = {
  __typename?: 'Dictionary';
  allTenants: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataFeed?: Maybe<Scalars['JSON']['output']>;
  dataset: Dataset;
  id: Scalars['ID']['output'];
  sections?: Maybe<Array<Section>>;
  tenants?: Maybe<Array<Tenant>>;
  type: DictionaryType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum DictionaryType {
  Biome = 'Biome',
  Vendor = 'Vendor',
}

export type Dimension = {
  __typename?: 'Dimension';
  aeQualifying: Scalars['Boolean']['output'];
  allMeasures: Scalars['Boolean']['output'];
  class: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dimensionSets: Array<DimensionSet>;
  dimensionValueSortOrder?: Maybe<Array<DimensionValueSortOrder>>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  excludeValues?: Maybe<Array<Scalars['String']['output']>>;
  fieldName: Scalars['String']['output'];
  hideFromReports: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isGlobal: Scalars['Boolean']['output'];
  kbFieldId?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  multiProcTable?: Maybe<MultiProcTable>;
  multiProcTableId?: Maybe<Scalars['String']['output']>;
  oeQualifying: Scalars['Boolean']['output'];
  pipelineElement?: Maybe<PipelineElement>;
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  sortType: SortType;
  sourceContinuousField?: Maybe<Scalars['String']['output']>;
  type: DimensionType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  valueMap?: Maybe<Scalars['JSON']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type DimensionSet = {
  __typename?: 'DimensionSet';
  dimensions: Array<Dimension>;
  id: Scalars['ID']['output'];
  measure: MeasureMetadata;
  measureId: Scalars['Float']['output'];
};

export enum DimensionType {
  Procedure = 'Procedure',
  SubGroup = 'SubGroup',
  Summary = 'Summary',
}

export type DimensionValueSortOrder = {
  __typename?: 'DimensionValueSortOrder';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dimension: Dimension;
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  valueLabel: Scalars['String']['output'];
};

export type DiseaseStateModule = {
  __typename?: 'DiseaseStateModule';
  adjustment?: Maybe<Array<Scalars['String']['output']>>;
  aggregateBeats: Array<AggregateBeat>;
  aggregationFn?: Maybe<Array<Scalars['String']['output']>>;
  beats: Array<Beat>;
  careEntities?: Maybe<Array<CareEntity>>;
  clinicalProgram: ClinicalProgram;
  clinicalProgramId: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  criticalDatasets?: Maybe<Array<Dataset>>;
  datasets?: Maybe<Array<Dataset>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  hideRiskAuditCharts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  multiProcTables?: Maybe<Array<MultiProcTable>>;
  name: Scalars['String']['output'];
  notificationLogs?: Maybe<Array<NotificationLogs>>;
  primaryDataset?: Maybe<Dataset>;
  primaryDatasetId?: Maybe<Scalars['Int']['output']>;
  riskMetrics?: Maybe<Array<RiskMetric>>;
  roles?: Maybe<Array<Role>>;
  strategyTemplates?: Maybe<Array<ObjectiveStrategyTemplate>>;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  supportedApps?: Maybe<Array<SupportedApps>>;
  supportsMultipleProcedures: Scalars['Boolean']['output'];
  tableName?: Maybe<Scalars['String']['output']>;
  type: DsmType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  workbookGroups?: Maybe<Array<WorkbookGroup>>;
  workbooks?: Maybe<Array<Workbook>>;
};

export type DiseaseStateModuleMultiProcTableInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tableName: Scalars['String']['input'];
};

export type DiseaseStateModuleRiskMetricInput = {
  columnName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Distribution List */
export type DistributionList = {
  __typename?: 'DistributionList';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  files?: Maybe<Array<File>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export type Documentation = {
  dependencies: Array<Documentation>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
};

export type DsmAdditionImpact = {
  __typename?: 'DsmAdditionImpact';
  affectedRoles?: Maybe<Array<Role>>;
  newRoles?: Maybe<Array<Scalars['String']['output']>>;
};

export type DsmPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type DsmRemovalImpact = {
  __typename?: 'DsmRemovalImpact';
  affectedParentRoles?: Maybe<Array<Role>>;
  removedRoles?: Maybe<Array<Role>>;
  submissions?: Maybe<Array<Submission>>;
};

export enum DsmType {
  AdvancedClinical = 'AdvancedClinical',
  Foundational = 'Foundational',
}

export enum EchoFieldCategory {
  AorticValve = 'AORTIC_VALVE',
  AsdVsd = 'ASD_VSD',
  Biome = 'BIOME',
  Cardiomyopathy = 'CARDIOMYOPATHY',
  Contrast = 'CONTRAST',
  La = 'LA',
  LvFunction = 'LV_FUNCTION',
  MitralValve = 'MITRAL_VALVE',
  Mmode = 'MMODE',
  PatientStudyDemographics = 'PATIENT_STUDY_DEMOGRAPHICS',
  PatientTracking = 'PATIENT_TRACKING',
  Pericardial = 'PERICARDIAL',
  PulmonicValve = 'PULMONIC_VALVE',
  Ra = 'RA',
  RightVentricle = 'RIGHT_VENTRICLE',
  RvFunction = 'RV_FUNCTION',
  StrainImaging = 'STRAIN_IMAGING',
  Symptoms = 'SYMPTOMS',
  Thrombi = 'THROMBI',
  Tricuspid = 'TRICUSPID',
}

export type EchoFinding = {
  __typename?: 'EchoFinding';
  age?: Maybe<Scalars['Float']['output']>;
  avRegurgitation?: Maybe<Scalars['String']['output']>;
  avStenosis?: Maybe<Scalars['String']['output']>;
  avStenosisText?: Maybe<Scalars['String']['output']>;
  biomeCaseUid?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeImportDt?: Maybe<Scalars['DateTime']['output']>;
  biomePatientUid?: Maybe<Scalars['String']['output']>;
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  caseId: Scalars['String']['output'];
  caselistModule: EchoFindingModule;
  caselistModuleName: Scalars['String']['output'];
  echoResultText?: Maybe<Scalars['String']['output']>;
  followups: Array<EchoFindingFollowup>;
  gender?: Maybe<Scalars['String']['output']>;
  latestStudyOnRecord?: Maybe<Scalars['Boolean']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mvRegurgitation?: Maybe<Scalars['String']['output']>;
  mvStenosis?: Maybe<Scalars['String']['output']>;
  orderDt?: Maybe<Scalars['DateTime']['output']>;
  otherValveDisease?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  procedureDt?: Maybe<Scalars['DateTime']['output']>;
  pvStenosis?: Maybe<Scalars['String']['output']>;
  race?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tvRegurgitation?: Maybe<Scalars['String']['output']>;
  tvStenosis?: Maybe<Scalars['String']['output']>;
};

export type EchoFindingField = {
  __typename?: 'EchoFindingField';
  caselistModule: EchoFindingModule;
  caselistModuleName: Scalars['String']['output'];
  category: EchoFieldCategory;
  common: Scalars['Boolean']['output'];
  computed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phi: Scalars['Boolean']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
  trained: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  visibility: VisibilityType;
};

export type EchoFindingFollowup = {
  __typename?: 'EchoFindingFollowup';
  biomeCaseUid: Scalars['String']['output'];
  biomePatientUid: Scalars['String']['output'];
  caselistModuleName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  finding?: Maybe<EchoFinding>;
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  statusId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type EchoFindingFollowupOption = {
  __typename?: 'EchoFindingFollowupOption';
  careEntities?: Maybe<Array<CareEntity>>;
  caselistModule: EchoFindingModule;
  caselistModuleName: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  hide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  scope: FollowupOptionScope;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type EchoFindingModule = {
  __typename?: 'EchoFindingModule';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenants?: Maybe<Array<Tenant>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type Element = {
  __typename?: 'Element';
  code?: Maybe<Scalars['String']['output']>;
  codeSystem?: Maybe<Scalars['String']['output']>;
  codeSystemName?: Maybe<Scalars['String']['output']>;
  codingInstructions?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataSource?: Maybe<ElementDataSourceType>;
  dataType?: Maybe<ElementDataType>;
  dbDataType?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Definition>;
  derivativeTransformations?: Maybe<Array<Transformation>>;
  elementReference: Scalars['String']['output'];
  hideFromReports: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isBaseElement: Scalars['Boolean']['output'];
  isDynamicList?: Maybe<Scalars['Boolean']['output']>;
  isFollowupElement: Scalars['Boolean']['output'];
  isHarvested?: Maybe<Scalars['Boolean']['output']>;
  isIdentifier: Scalars['Boolean']['output'];
  missingData?: Maybe<ElementMissingDataAction>;
  name: Scalars['String']['output'];
  parentChildValidations?: Maybe<Array<ParentChildValidation>>;
  phi?: Maybe<Scalars['Boolean']['output']>;
  pipelineElements: Array<PipelineElement>;
  precision?: Maybe<Scalars['String']['output']>;
  ranges?: Maybe<Array<Range>>;
  referenceTransformations?: Maybe<Array<Transformation>>;
  reports: Array<Report>;
  role?: Maybe<Scalars['String']['output']>;
  section: Section;
  sectionId: Scalars['String']['output'];
  selectionType?: Maybe<ElementSelectionType>;
  selections?: Maybe<Array<Selection>>;
  shortName: Scalars['String']['output'];
  sourceMappings?: Maybe<Array<Translation>>;
  targetMappings?: Maybe<Array<Translation>>;
  targetValue?: Maybe<Scalars['String']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  vendorInstruction?: Maybe<Scalars['String']['output']>;
};

export enum ElementDataSourceType {
  Automatic = 'Automatic',
  Computed = 'Computed',
  Lookup = 'Lookup',
  User = 'User',
  UserOrAutomatic = 'UserOrAutomatic',
  UserOrComputed = 'UserOrComputed',
}

export enum ElementDataType {
  Bl = 'BL',
  Cd = 'CD',
  Ctr = 'CTR',
  Dt = 'DT',
  Fn = 'FN',
  Ln = 'LN',
  Mn = 'MN',
  Num = 'NUM',
  Pq = 'PQ',
  Real = 'Real',
  St = 'ST',
  Tm = 'TM',
  Ts = 'TS',
}

export enum ElementMissingDataAction {
  Illegal = 'Illegal',
  NoAction = 'NoAction',
  Report = 'Report',
}

export enum ElementSelectionType {
  Multiple = 'Multiple',
  Single = 'Single',
}

export type EnableUserInput = {
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  username: Scalars['String']['input'];
};

export enum EnforcerType {
  Admin = 'Admin',
  Case = 'Case',
  Clinician = 'Clinician',
  Dashboard = 'Dashboard',
  DiseaseStateModule = 'DiseaseStateModule',
  Entity = 'Entity',
  File = 'File',
  General = 'General',
  Initiative = 'Initiative',
  PatientList = 'PatientList',
  StrategyBoard = 'StrategyBoard',
  Tenant = 'Tenant',
  User = 'User',
}

export type EntityPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export enum EntityState {
  Development = 'Development',
  ProductionDeployment = 'ProductionDeployment',
  Release = 'Release',
  Request = 'Request',
}

export enum EntityStatus {
  CancelledArchived = 'CancelledArchived',
  CodeReviewApproved = 'CodeReviewApproved',
  Draft = 'Draft',
  MergedToProduction = 'MergedToProduction',
  MergedToStaging = 'MergedToStaging',
  OeDataMoveToProdCompleted = 'OeDataMoveToProdCompleted',
  OeDataMoveToProdFailed = 'OeDataMoveToProdFailed',
  OeDataMoveToProdStarted = 'OeDataMoveToProdStarted',
  OePipelineCompleted = 'OePipelineCompleted',
  OePipelineFailed = 'OePipelineFailed',
  OePipelineStarted = 'OePipelineStarted',
  Planned = 'Planned',
  ProductionPipelineCompleted = 'ProductionPipelineCompleted',
  ProductionPipelineFailed = 'ProductionPipelineFailed',
  ReStarted = 'ReStarted',
  Ready = 'Ready',
  ReadyForPeerReview = 'ReadyForPeerReview',
  ReadyForSmeReview = 'ReadyForSmeReview',
  SmeReviewApproved = 'SmeReviewApproved',
  SmeReviewRejected = 'SmeReviewRejected',
  StagingPipelineCompleted = 'StagingPipelineCompleted',
  StagingPipelineFailed = 'StagingPipelineFailed',
  Started = 'Started',
}

export type EntraIdGroup = {
  __typename?: 'EntraIdGroup';
  /** Description of the group. */
  description?: Maybe<Scalars['String']['output']>;
  /** Every entry in the directory has a distinguished name (DN). The DN is the name that uniquely identifies an entry in the directory. It is a sequence of relative distinguished names (RDN) connected by commas. An RDN is an attribute with an associated value in the form attribute=value; normally expressed in a UTF-8 string format. RDN attributes consist of commonName (CN), organizationalUnitName (OU) and so on. */
  distinguishedName?: Maybe<Scalars['String']['output']>;
  /** The azure group's acoount-id to identify it uniquely. */
  id: Scalars['String']['output'];
  /** Display name of the group */
  name?: Maybe<Scalars['String']['output']>;
};

export enum EtlAvailability {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type ExplicitCareEntityUser = {
  __typename?: 'ExplicitCareEntityUser';
  careEntityCode: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  submitsData: Scalars['Boolean']['output'];
  tenantCode: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  tenantName: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type ExplicitCareEntityUserPage = {
  __typename?: 'ExplicitCareEntityUserPage';
  /** Pass as `after` to read the next page; null when this page is the last. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  users: Array<ExplicitCareEntityUser>;
};

export enum ExtensionType {
  Avi = 'AVI',
  Cs3916 = 'CS3916',
  Csv = 'CSV',
  Dat = 'DAT',
  Db = 'DB',
  Docx = 'DOCX',
  Em5144 = 'EM5144',
  Filepart = 'FILEPART',
  Fl5144 = 'FL5144',
  Fx5144 = 'FX5144',
  Gpg = 'GPG',
  Gq1808 = 'GQ1808',
  Gq2892 = 'GQ2892',
  Gq3448 = 'GQ3448',
  Gq3968 = 'GQ3968',
  Gq4304 = 'GQ4304',
  Gq4380 = 'GQ4380',
  Gq5144 = 'GQ5144',
  Html = 'HTML',
  Job = 'JOB',
  Ly5144 = 'LY5144',
  Mht = 'MHT',
  Mp4 = 'MP4',
  Msg = 'MSG',
  Ods = 'ODS',
  Other = 'Other',
  Pdf = 'PDF',
  Pgp = 'PGP',
  Pptx = 'PPTX',
  Prn = 'PRN',
  Rep = 'REP',
  Rpt = 'RPT',
  Rtf = 'RTF',
  Samplexlsx = 'SAMPLEXLSX',
  Sevenz = 'SEVENZ',
  Sh = 'SH',
  Sql = 'SQL',
  Tsv = 'TSV',
  Txt = 'TXT',
  Unsupported = 'UNSUPPORTED',
  Url = 'URL',
  Xls = 'XLS',
  Xlsm = 'XLSM',
  Xlsx = 'XLSX',
  Xml = 'XML',
  Zip = 'ZIP',
}

/** File */
export type File = {
  __typename?: 'File';
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributionLists?: Maybe<Array<DistributionList>>;
  extension: Scalars['String']['output'];
  fileLabel?: Maybe<FileLabel>;
  fileShareDate?: Maybe<Scalars['DateTime']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  objectiveStrategyId?: Maybe<Scalars['String']['output']>;
  objectiveStrategyTemplateId?: Maybe<Scalars['String']['output']>;
  phi?: Maybe<Scalars['Boolean']['output']>;
  report?: Maybe<Report>;
  reportId?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  url: Scalars['String']['output'];
  users: Array<FileUser>;
};

export type FileDistributionList = {
  __typename?: 'FileDistributionList';
  distributionLists?: Maybe<Array<DistributionList>>;
  file: File;
  fileSharedDate?: Maybe<Scalars['DateTime']['output']>;
  isDirect: Scalars['Boolean']['output'];
};

export type FileInput = {
  category: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extension: Scalars['String']['input'];
  fileLabel?: InputMaybe<UpdateFileLabelInput>;
  historicPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  phi?: InputMaybe<Scalars['Boolean']['input']>;
  report?: InputMaybe<UpdateReportInput>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type FileLabel = {
  __typename?: 'FileLabel';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  files?: Maybe<Array<File>>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy: User;
};

export type FilePolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type FileShareNotification = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  sendNotification: Scalars['Boolean']['input'];
};

export type FileUser = {
  __typename?: 'FileUser';
  distributionLists?: Maybe<Array<DistributionList>>;
  isDirect?: Maybe<Scalars['Boolean']['output']>;
  user: User;
};

export type FileUserInput = {
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  isDirect?: InputMaybe<Scalars['Boolean']['input']>;
  user: UpdateUserInput;
};

export enum FlagType {
  AdminFinanceFlag = 'AdminFinanceFlag',
  RegistryFlag = 'RegistryFlag',
}

export enum FollowupOptionScope {
  CareEntity = 'CARE_ENTITY',
  Global = 'GLOBAL',
  Tenant = 'TENANT',
}

export type GeneralPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type GenerateStandardRolesInput = {
  dsmIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  tenantId: Scalars['String']['input'];
  types: Array<RoleType>;
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  authnContext: Scalars['String']['output'];
  certificate: Scalars['String']['output'];
  certificates?: Maybe<Array<Certificate>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  defaultRoles?: Maybe<Array<Role>>;
  description: Scalars['String']['output'];
  emailAttribute: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityId: Scalars['String']['output'];
  entryPoint: Scalars['String']['output'];
  firstNameAttribute: Scalars['String']['output'];
  forceAuthentication: Scalars['Boolean']['output'];
  groupAccessType?: Maybe<IdentityProviderGroupAccessType>;
  id: Scalars['ID']['output'];
  identifierFormat: Scalars['String']['output'];
  lastNameAttribute: Scalars['String']['output'];
  loginRoute: LoginRoute;
  logoutUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  provisionUsers: Scalars['Boolean']['output'];
  securityGroup?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  updateUsers: Scalars['Boolean']['output'];
};

export enum IdentityProviderGroupAccessType {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export enum IngestionState {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type InitiativePolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export enum InputTrackingStatus {
  Complete = 'Complete',
  Failed = 'Failed',
  NotAttempted = 'NotAttempted',
  Partial = 'Partial',
  Queued = 'Queued',
}

export type JiraIssue = {
  __typename?: 'JiraIssue';
  clientDataFile?: Maybe<ClientDataFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Jira Issue Key */
  key: Scalars['String']['output'];
  lastEventId?: Maybe<Scalars['String']['output']>;
  month: Month;
  rootTriggerId?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  type: JiraIssueType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export enum JiraIssueType {
  Bug = 'Bug',
  Epic = 'Epic',
  Story = 'Story',
  Task = 'Task',
}

export type Job = {
  __typename?: 'Job';
  additionalInfo: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  events?: Maybe<Array<JobEvent>>;
  id: Scalars['ID']['output'];
  /** The type of job to be created */
  jobType: JobType;
  parent?: Maybe<Job>;
  parentId?: Maybe<Scalars['String']['output']>;
  presentations?: Maybe<Array<Presentation>>;
  /** Jobs that were retried from this job */
  retriedAs?: Maybe<Array<Job>>;
  /** The failed job this job was retried from, if any */
  retriedFromJobId?: Maybe<Scalars['String']['output']>;
  /** The roles for which the job was created */
  roles?: Maybe<Array<Role>>;
  rootJobId: Scalars['String']['output'];
  /** The status of the job */
  status: JobEventType;
  statusTime: Scalars['DateTime']['output'];
  /** The tenants for which the job was created */
  tenants?: Maybe<Array<Tenant>>;
  /** The users for which the job was created */
  users?: Maybe<Array<User>>;
};

export type JobEvent = {
  __typename?: 'JobEvent';
  /** The type of event that occurred */
  eventType: JobEventType;
  id: Scalars['ID']['output'];
  job: Job;
  message?: Maybe<Scalars['ID']['output']>;
  occuredAt: Scalars['DateTime']['output'];
};

export enum JobEventType {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  CompletedWithFailures = 'CompletedWithFailures',
  Created = 'Created',
  Failed = 'Failed',
  PendingCancellation = 'PendingCancellation',
  Retrying = 'Retrying',
  Stalled = 'Stalled',
  Waiting = 'Waiting',
}

export type JobProgressNode = {
  __typename?: 'JobProgressNode';
  childJob?: Maybe<JobProgressTree>;
  childJobId?: Maybe<Scalars['String']['output']>;
  children: Array<JobProgressNode>;
  completedUnits: Scalars['Float']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  parentStepId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: JobStepStatus;
  totalUnits: Scalars['Float']['output'];
  type: JobStepType;
  weight: Scalars['Float']['output'];
};

export type JobProgressSummary = {
  __typename?: 'JobProgressSummary';
  jobId: Scalars['String']['output'];
  overallPercent: Scalars['Int']['output'];
  status: JobEventType;
  stepsCompleted: Scalars['Int']['output'];
  stepsTotal: Scalars['Int']['output'];
};

export type JobProgressTree = {
  __typename?: 'JobProgressTree';
  nodes: Array<JobProgressNode>;
  summary: JobProgressSummary;
};

export enum JobStepStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  NotRun = 'NotRun',
  Pending = 'Pending',
  Running = 'Running',
  Skipped = 'Skipped',
}

export enum JobStepType {
  JobLink = 'JobLink',
  Step = 'Step',
}

export enum JobType {
  CalculateExpectedVolume = 'CalculateExpectedVolume',
  EnsureAndAssociateBeats = 'EnsureAndAssociateBeats',
  EnumerateDataflowRunInputs = 'EnumerateDataflowRunInputs',
  EnumerateOePipelineRunInputs = 'EnumerateOePipelineRunInputs',
  GenerateBeats = 'GenerateBeats',
  GenerateReport = 'GenerateReport',
  GenerateStandardRoles = 'GenerateStandardRoles',
  IngestionAndMaskedCleanUp = 'IngestionAndMaskedCleanUp',
  PresentationClone = 'PresentationClone',
  PresentationImagesRefresh = 'PresentationImagesRefresh',
  PresentationSlidesGeneration = 'PresentationSlidesGeneration',
  PresentationSubmissionClone = 'PresentationSubmissionClone',
  ProcessInitiativesNotifications = 'ProcessInitiativesNotifications',
  ProcessSubmissionReminders = 'ProcessSubmissionReminders',
  PublishEvent = 'PublishEvent',
  PushEchoWorkflowSelections = 'PushEchoWorkflowSelections',
  RemoveRoles = 'RemoveRoles',
  RowLevelSecuritySync = 'RowLevelSecuritySync',
  StandardRolesRefresh = 'StandardRolesRefresh',
  TenantOffboardingDestroy = 'TenantOffboardingDestroy',
  TenantOffboardingDryRun = 'TenantOffboardingDryRun',
}

export type LifelineActionError = {
  __typename?: 'LifelineActionError';
  clientDataFile: ClientDataFile;
  clientDataFileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataframe?: Maybe<DataFrame>;
  dataframeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  rootTriggerId?: Maybe<Scalars['String']['output']>;
  type: LifelineActionType;
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum LifelineActionType {
  Cleanup = 'CLEANUP',
  IgnoreFile = 'IGNORE_FILE',
  IgnoreMaskerWarnings = 'IGNORE_MASKER_WARNINGS',
  IngestionCleanupJob = 'INGESTION_CLEANUP_JOB',
  MaskedCleanupJob = 'MASKED_CLEANUP_JOB',
  OverrideCrosswalkFailure = 'OVERRIDE_CROSSWALK_FAILURE',
  Reprocess = 'REPROCESS',
  TriggerStep = 'TRIGGER_STEP',
  UpdateValidation = 'UPDATE_VALIDATION',
}

export type LifelineEvent = {
  __typename?: 'LifelineEvent';
  beats: Array<Beat>;
  clientDataFileFamilies: Array<ClientDataFileFamily>;
  clientDataFiles: Array<ClientDataFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['JSON']['output']>;
  dataframes: Array<DataFrame>;
  datasetInstances: Array<DatasetInstance>;
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export type LoginRoute = {
  __typename?: 'LoginRoute';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identityProvider: IdentityProvider;
  identityProviderId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

export type LoginRouteInput = {
  domain: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  identityProvider: UpdateIdentityProviderInput;
};

export enum MaskState {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type MaskedDataframeLocations = {
  __typename?: 'MaskedDataframeLocations';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataframe: DataFrame;
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  locationType: DataframeLocationType;
  name: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export enum MaskerState {
  CompletedWithWarnings = 'COMPLETED_WITH_WARNINGS',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  ManualOverride = 'MANUAL_OVERRIDE',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export enum MeasureInputDataType {
  Admin = 'Admin',
  AdminAndCost = 'AdminAndCost',
  Clinical = 'Clinical',
  Cost = 'Cost',
}

export type MeasureLink = {
  __typename?: 'MeasureLink';
  id: Scalars['ID']['output'];
  link: MeasureLinkType;
  objectId: Scalars['Float']['output'];
  objectMeasure: MeasureMetadata;
  processMeasure: Scalars['Boolean']['output'];
  subjectId: Scalars['Float']['output'];
  subjectMeasure: MeasureMetadata;
};

export enum MeasureLinkType {
  Balances = 'Balances',
  Influences = 'Influences',
  RelatesTo = 'RelatesTo',
}

export type MeasureMetadata = {
  __typename?: 'MeasureMetadata';
  accessCategory: AccessCategory;
  adjustment?: Maybe<Array<Scalars['String']['output']>>;
  aggregationFn?: Maybe<Array<Scalars['String']['output']>>;
  aggregationType?: Maybe<SummaryCalculationType>;
  annualMeasureBaseId?: Maybe<Scalars['String']['output']>;
  benchmarkExtraction: Scalars['Boolean']['output'];
  children?: Maybe<Array<MeasureMetadata>>;
  commonMeasureDisplayName: Scalars['String']['output'];
  commonMeasureQualifying?: Maybe<Scalars['Boolean']['output']>;
  costComponentMeasure?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  dataTypeRequired?: Maybe<MeasureInputDataType>;
  denominatorColumnName?: Maybe<Scalars['String']['output']>;
  denominatorLegacyDescription?: Maybe<Scalars['String']['output']>;
  denominatorPipelineElement?: Maybe<PipelineElement>;
  denominatorPipelineElementId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developedOn?: Maybe<Scalars['DateTime']['output']>;
  dimensionSets?: Maybe<Array<DimensionSet>>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  excludedCohortIds?: Maybe<Array<Scalars['Float']['output']>>;
  hideFromReports: Scalars['Boolean']['output'];
  higherIsBetter?: Maybe<Scalars['Boolean']['output']>;
  history: Array<MeasureMetadataHistory>;
  id: Scalars['Int']['output'];
  includeColumnName?: Maybe<Scalars['String']['output']>;
  includePipelineElement?: Maybe<PipelineElement>;
  includePipelineElementId?: Maybe<Scalars['String']['output']>;
  isBenchmark?: Maybe<Scalars['Boolean']['output']>;
  losROIQualifying?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  ncdrMeasureName?: Maybe<Scalars['String']['output']>;
  numeratorColumnName?: Maybe<Scalars['String']['output']>;
  numeratorLegacyDescription?: Maybe<Scalars['String']['output']>;
  numeratorPipelineElement?: Maybe<PipelineElement>;
  numeratorPipelineElementId?: Maybe<Scalars['String']['output']>;
  numeratorUnit: Scalars['String']['output'];
  objectiveTemplates?: Maybe<Array<ObjectiveTemplate>>;
  objectives?: Maybe<Array<Objective>>;
  objects?: Maybe<Array<MeasureLink>>;
  opportunityType: Array<OpportunityType>;
  outcomeType?: Maybe<MeasureOutcomeType>;
  parent?: Maybe<MeasureMetadata>;
  parentId?: Maybe<Scalars['ID']['output']>;
  publicationSource?: Maybe<Array<PublicationSource>>;
  rareEvent: Scalars['Boolean']['output'];
  registryMeasureId?: Maybe<Scalars['Int']['output']>;
  reportRowId?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  riskAdjusted: Scalars['Boolean']['output'];
  riskMetric?: Maybe<RiskMetric>;
  riskMetricId?: Maybe<Scalars['String']['output']>;
  riskMetricPipelineElement?: Maybe<PipelineElement>;
  riskMetricPipelineElementId?: Maybe<Scalars['String']['output']>;
  roiCalcType?: Maybe<SummaryCalculationType>;
  roiMetrics?: Maybe<Array<RoiMetric>>;
  strategyTemplates?: Maybe<Array<ObjectiveStrategyTemplate>>;
  subjects?: Maybe<Array<MeasureLink>>;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  summaryInitiativeMeasure: Scalars['Boolean']['output'];
  tableName?: Maybe<Scalars['String']['output']>;
  tableauViews?: Maybe<Array<MeasureTableauView>>;
  testCapture?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
  validationSource?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  volumeMeasure?: Maybe<Scalars['Boolean']['output']>;
};

export type MeasureMetadataHistory = {
  __typename?: 'MeasureMetadataHistory';
  accessCategory: AccessCategory;
  adjustment?: Maybe<Array<Scalars['String']['output']>>;
  aggregationFn?: Maybe<Array<Scalars['String']['output']>>;
  aggregationType?: Maybe<SummaryCalculationType>;
  commonMeasureDisplayName: Scalars['String']['output'];
  commonMeasureQualifying?: Maybe<Scalars['Boolean']['output']>;
  costComponentMeasure?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataTypeRequired?: Maybe<MeasureInputDataType>;
  denominatorColumnName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensionSets?: Maybe<Scalars['JSON']['output']>;
  diseaseStateModule: Scalars['JSON']['output'];
  excludedCohortIds?: Maybe<Array<Scalars['Int']['output']>>;
  higherIsBetter?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  includeColumnName?: Maybe<Scalars['String']['output']>;
  isBenchmark?: Maybe<Scalars['Boolean']['output']>;
  losROIQualifying?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  ncdrMeasureName?: Maybe<Scalars['String']['output']>;
  numeratorColumnName?: Maybe<Scalars['String']['output']>;
  numeratorUnit?: Maybe<Scalars['String']['output']>;
  opportunityType: Array<OpportunityType>;
  outcomeType?: Maybe<MeasureOutcomeType>;
  publicationSource?: Maybe<Array<PublicationSource>>;
  rareEvent: Scalars['Boolean']['output'];
  riskMetric?: Maybe<RiskMetric>;
  riskMetricId?: Maybe<Scalars['String']['output']>;
  roiCalcType?: Maybe<SummaryCalculationType>;
  roiMetrics?: Maybe<Scalars['JSON']['output']>;
  summaryCohortId?: Maybe<Scalars['Float']['output']>;
  summaryInitiativeMeasure: Scalars['Boolean']['output'];
  tableName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum MeasureOutcomeType {
  Binary = 'Binary',
  Continuous = 'Continuous',
  Oer = 'Oer',
}

export type MeasureTableauView = {
  __typename?: 'MeasureTableauView';
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  measure: MeasureMetadata;
  measureId: Scalars['Int']['output'];
  tableauView: TableauView;
  tableauViewId: Scalars['Int']['output'];
};

export enum Month {
  April = 'April',
  August = 'August',
  December = 'December',
  February = 'February',
  January = 'January',
  July = 'July',
  June = 'June',
  March = 'March',
  May = 'May',
  November = 'November',
  October = 'October',
  September = 'September',
}

export enum MovedToProdStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Success = 'Success',
}

export type MultiProcTable = {
  __typename?: 'MultiProcTable';
  developmentDimensions?: Maybe<Array<DevelopmentDimension>>;
  dimensions?: Maybe<Array<Dimension>>;
  diseaseStateModule: DiseaseStateModule;
  id: Scalars['ID']['output'];
  tableName: Scalars['String']['output'];
};

export type MultiProcTableDeletionActionInput = {
  multiProcTableId: Scalars['ID']['input'];
  replacementMultiProcTableId?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  archiveDiseaseStateModule: DiseaseStateModule;
  assignTenantToBiomeUsers: Scalars['Boolean']['output'];
  /** Change user password */
  changePassword: Scalars['Boolean']['output'];
  /** Change password of the requester */
  changeRequesterPassword: Scalars['Boolean']['output'];
  /** Deletes existing Admin policies for a role and re-creates as per requested in this mutation */
  createAdminPolicies: Scalars['Boolean']['output'];
  createApplicationNotice: ApplicationNotice;
  createBulkCareEntities: Array<CareEntity>;
  createCareEntity: CareEntity;
  /** Deletes existing Case policies for a role and re-creates as per requested in this mutation */
  createCasePolicies: Scalars['Boolean']['output'];
  /** Deletes existing Clinician policies for a role and re-creates as per requested in this mutation */
  createClinicianPolicies: Scalars['Boolean']['output'];
  /** Deletes existing Dashboard policies for a role and re-creates as per requested in this mutation */
  createDashboardPolicies: Scalars['Boolean']['output'];
  createDiseaseStateModule: DiseaseStateModule;
  /** Deletes existing DiseaseStateModule policies for a role and re-creates as per requested in this mutation */
  createDsmPolicies: Scalars['Boolean']['output'];
  /** Deletes existing Entity policies for a role and re-creates as per requested in this mutation */
  createEntityPolicies: Scalars['Boolean']['output'];
  /** Deletes existing File policies for a role/user and re-creates as per requested in this mutation */
  createFilePolicies: Scalars['Boolean']['output'];
  /** Deletes existing General policies for a role and re-creates as per requested in this mutation */
  createGeneralPolicies: Scalars['Boolean']['output'];
  /** Deletes existing Initiative policies for a role and re-creates as per requested in this mutation */
  createInitiativePolicies: Scalars['Boolean']['output'];
  createLoginRoutes: Array<LoginRoute>;
  /** Deletes existing PatientList policies for a role and re-creates as per requested in this mutation */
  createPatientListPolicies: Scalars['Boolean']['output'];
  createRole: Role;
  /** Deletes existing Strategy Board policies for a role and re-creates as per requested in this mutation */
  createStrategyBoardPolicies: Scalars['Boolean']['output'];
  createUrlMap: UrlMap;
  createUser: User;
  /** Deletes existing user policies for a role and re-creates as per requested in this mutation */
  createUserPolicies: Scalars['Boolean']['output'];
  enableUser: Scalars['Boolean']['output'];
  /** It will send a reset password link through email */
  forgotPassword: Scalars['Boolean']['output'];
  /** It will send username along with reset password link through email */
  forgotUsername: Scalars['Boolean']['output'];
  generateStandardRoles: Scalars['Boolean']['output'];
  /**
   * Initiates a job to remove and recreate policies for the given standard roles.
   *       This is useful when the policy rules change and all existing standard roles need to be realigned.
   */
  refreshStandardRoles: Scalars['Boolean']['output'];
  /** Reloads cached enforcer policies */
  reloadCachedPolicies: Scalars['Boolean']['output'];
  /** Deletes the admin policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeAdminPolicies: Scalars['Boolean']['output'];
  removeCareEntity: Scalars['Boolean']['output'];
  /** Deletes the Case policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeCasePolicies: Scalars['Boolean']['output'];
  /** Deletes the Clinician policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeClinicianPolicies: Scalars['Boolean']['output'];
  /** Deletes the Dashboard policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeDashboardPolicies: Scalars['Boolean']['output'];
  removeDiseaseStateModule: Scalars['Boolean']['output'];
  /** Deletes the DiseaseStateModule policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeDsmPolicies: Scalars['Boolean']['output'];
  /** Deletes the Entity policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeEntityPolicies: Scalars['Boolean']['output'];
  /** Deletes the file policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeFilePolicies: Scalars['Boolean']['output'];
  /** Deletes the General policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeGeneralEntityPolicies: Scalars['Boolean']['output'];
  /** Deletes the Initiative policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeInitiativePolicies: Scalars['Boolean']['output'];
  removeLoginRoute: Scalars['Boolean']['output'];
  /** Deletes the PatientList policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removePatientListPolicies: Scalars['Boolean']['output'];
  removeRoles: Scalars['Boolean']['output'];
  /** Deletes the Strategy Board policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeStrategyBoardPolicies: Scalars['Boolean']['output'];
  removeUrlMap: Scalars['Boolean']['output'];
  removeUser: Scalars['Boolean']['output'];
  /** Deletes the user policies from policyInputs for the given role or all policies if policyInputs is not provided */
  removeUserPolicies: Scalars['Boolean']['output'];
  /** Resets user password and sends onboarding email */
  resendOnboardingEmail: Scalars['Boolean']['output'];
  /** Initiates a password reset request for the user and sends a reset password link to user's email. */
  resetPassword: Scalars['Boolean']['output'];
  shareFilesWithUsers: Scalars['Boolean']['output'];
  softDeleteCareEntity: Scalars['Boolean']['output'];
  softDeleteUser: Scalars['Boolean']['output'];
  syncRoleRowLevelSecurity: Scalars['Boolean']['output'];
  syncTenantRowLevelSecurity: Scalars['Boolean']['output'];
  syncUserRowLevelSecurity: Scalars['Boolean']['output'];
  unarchiveDiseaseStateModule: DiseaseStateModule;
  updateApplicationNotice: ApplicationNotice;
  updateCareEntity: CareEntity;
  updateDiseaseStateModule: DiseaseStateModule;
  updateLoginRoute: LoginRoute;
  updateRole: Role;
  updateUrlMap: UrlMap;
  updateUser: User;
  updateUserAccount: User;
};

export type MutationArchiveDiseaseStateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAssignTenantToBiomeUsersArgs = {
  biomeUserRegion?: InputMaybe<BiomeUserRegion>;
  tenantId: Scalars['String']['input'];
};

export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MutationChangeRequesterPasswordArgs = {
  newPassword: Scalars['String']['input'];
};

export type MutationCreateAdminPoliciesArgs = {
  policyInputs: Array<AdminPolicyInput>;
};

export type MutationCreateApplicationNoticeArgs = {
  input: CreateApplicationNoticeInput;
};

export type MutationCreateBulkCareEntitiesArgs = {
  inputs: Array<CreateBulkCareEntityInput>;
};

export type MutationCreateCareEntityArgs = {
  createCareEntityInput: CreateCareEntityInput;
};

export type MutationCreateCasePoliciesArgs = {
  policyInputs: Array<CasePolicyInput>;
};

export type MutationCreateClinicianPoliciesArgs = {
  policyInputs: Array<ClinicianPolicyInput>;
};

export type MutationCreateDashboardPoliciesArgs = {
  policyInputs: Array<DashboardPolicyInput>;
};

export type MutationCreateDiseaseStateModuleArgs = {
  createDiseaseStateModuleInput: CreateDiseaseStateModuleInput;
};

export type MutationCreateDsmPoliciesArgs = {
  policyInputs: Array<DsmPolicyInput>;
};

export type MutationCreateEntityPoliciesArgs = {
  policyInputs: Array<EntityPolicyInput>;
};

export type MutationCreateFilePoliciesArgs = {
  policyInputs: Array<FilePolicyInput>;
};

export type MutationCreateGeneralPoliciesArgs = {
  policyInputs: Array<GeneralPolicyInput>;
};

export type MutationCreateInitiativePoliciesArgs = {
  policyInputs: Array<InitiativePolicyInput>;
};

export type MutationCreateLoginRoutesArgs = {
  loginInputs: Array<LoginRouteInput>;
};

export type MutationCreatePatientListPoliciesArgs = {
  policyInputs: Array<PatientListPolicyInput>;
};

export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};

export type MutationCreateStrategyBoardPoliciesArgs = {
  policyInputs: Array<StrategyBoardPolicyInput>;
};

export type MutationCreateUrlMapArgs = {
  input: CreateUrlMapInput;
};

export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};

export type MutationCreateUserPoliciesArgs = {
  policyInputs: Array<UserPolicyInput>;
};

export type MutationEnableUserArgs = {
  alternativeUserId: Scalars['String']['input'];
  enableUserInput: EnableUserInput;
};

export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};

export type MutationForgotUsernameArgs = {
  email: Scalars['String']['input'];
};

export type MutationGenerateStandardRolesArgs = {
  input: GenerateStandardRolesInput;
};

export type MutationRefreshStandardRolesArgs = {
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleTypes?: InputMaybe<Array<RoleType>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRemoveAdminPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<AdminPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveCareEntityArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveCasePoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<CasePolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveClinicianPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<ClinicianPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveDashboardPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<DashboardPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveDiseaseStateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveDsmPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<DsmPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveEntityPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<EntityPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveFilePoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<FilePolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveGeneralEntityPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<GeneralPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveInitiativePoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<InitiativePolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveLoginRouteArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemovePatientListPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<PatientListPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveRolesArgs = {
  ids: Array<Scalars['String']['input']>;
};

export type MutationRemoveStrategyBoardPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<StrategyBoardPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationRemoveUrlMapArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveUserArgs = {
  id: Scalars['String']['input'];
};

export type MutationRemoveUserPoliciesArgs = {
  comment: Scalars['String']['input'];
  policyInputs?: InputMaybe<Array<UserPolicyInput>>;
  subjectId: Scalars['String']['input'];
};

export type MutationResendOnboardingEmailArgs = {
  userId: Scalars['String']['input'];
};

export type MutationResetPasswordArgs = {
  passwordResetInput: PasswordResetInput;
};

export type MutationShareFilesWithUsersArgs = {
  fileShareNotification?: InputMaybe<FileShareNotification>;
  userFileShareInputs: Array<UpdateUserInput>;
};

export type MutationSoftDeleteCareEntityArgs = {
  id: Scalars['String']['input'];
};

export type MutationSoftDeleteUserArgs = {
  id: Scalars['String']['input'];
};

export type MutationSyncRoleRowLevelSecurityArgs = {
  roleId: Scalars['String']['input'];
};

export type MutationSyncTenantRowLevelSecurityArgs = {
  tenantId: Scalars['String']['input'];
};

export type MutationSyncUserRowLevelSecurityArgs = {
  userId: Scalars['String']['input'];
};

export type MutationUnarchiveDiseaseStateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUpdateApplicationNoticeArgs = {
  input: UpdateApplicationNoticeInput;
};

export type MutationUpdateCareEntityArgs = {
  updateCareEntityInput: UpdateCareEntityInput;
};

export type MutationUpdateDiseaseStateModuleArgs = {
  updateDiseaseStateModuleInput: UpdateDiseaseStateModuleInput;
};

export type MutationUpdateLoginRouteArgs = {
  updateLoginRouteInput: UpdateLoginRouteInput;
};

export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};

export type MutationUpdateUrlMapArgs = {
  input: UpdateUrlMapInput;
};

export type MutationUpdateUserArgs = {
  fileShareNotification?: InputMaybe<FileShareNotification>;
  updateUserInput: UpdateUserInput;
};

export type MutationUpdateUserAccountArgs = {
  updateUserInput: UpdateUserAccountInput;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  /** Description of the notification */
  description?: Maybe<Scalars['String']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationLogs?: Maybe<Array<NotificationLogs>>;
  type: NotificationType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export type NotificationLogs = {
  __typename?: 'NotificationLogs';
  /** Creation Datetime */
  createdAt: Scalars['DateTime']['output'];
  dsm?: Maybe<DiseaseStateModule>;
  dsmId?: Maybe<Scalars['Int']['output']>;
  /** Auto increment ID */
  id: Scalars['ID']['output'];
  notification: Notification;
  notificationId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  /** Modification Datetime */
  updateAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export enum NotificationType {
  DataRefreshEmails = 'DataRefreshEmails',
  EchoSummaryEmails = 'EchoSummaryEmails',
  ProductNewsUpdates = 'ProductNewsUpdates',
  RiskAuditEmails = 'RiskAuditEmails',
}

export type Objective = {
  __typename?: 'Objective';
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  cohortIds?: Maybe<Array<Scalars['Float']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  /** Source: Perf Api initiative list */
  initiativeId?: Maybe<Scalars['Float']['output']>;
  measures?: Maybe<Array<MeasureMetadata>>;
  /** Title of the objective, populate based on measure & cohort in case of Opportunity objective */
  name: Scalars['String']['output'];
  participants?: Maybe<Array<ObjectiveParticipant>>;
  physicianChampions?: Maybe<Array<ObjectiveParticipant>>;
  processSponsors?: Maybe<Array<ObjectiveParticipant>>;
  strategies?: Maybe<Array<ObjectiveStrategy>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ObjectiveParticipant = {
  __typename?: 'ObjectiveParticipant';
  createdAt: Scalars['DateTime']['output'];
  /** Free text username/email for external participants not in User table */
  externalUsername?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objective: Objective;
  objectiveId: Scalars['String']['output'];
  role: ParticipantRole;
  updateAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ObjectiveStrategy = {
  __typename?: 'ObjectiveStrategy';
  associations?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<File>>;
  checkpointDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objective: Objective;
  objectiveId: Scalars['ID']['output'];
  participants?: Maybe<Array<StrategyParticipant>>;
  physicianChampions?: Maybe<Array<StrategyParticipant>>;
  processSponsors?: Maybe<Array<StrategyParticipant>>;
  resources?: Maybe<Array<ObjectiveStrategyResource>>;
  showInPerformanceMonitor: Scalars['Boolean']['output'];
  status: ObjectiveStrategyStatus;
  template?: Maybe<ObjectiveStrategyTemplate>;
  templateId?: Maybe<Scalars['ID']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ObjectiveStrategyResource = {
  __typename?: 'ObjectiveStrategyResource';
  createdAt: Scalars['DateTime']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectiveStrategy: ObjectiveStrategy;
  objectiveStrategyId: Scalars['ID']['output'];
  updateAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export enum ObjectiveStrategyStatus {
  AttentionRequired = 'ATTENTION_REQUIRED',
  Completed = 'COMPLETED',
  OnTrack = 'ON_TRACK',
  Stalled = 'STALLED',
}

export type ObjectiveStrategyTemplate = {
  __typename?: 'ObjectiveStrategyTemplate';
  allDiseaseStateModules: Scalars['Boolean']['output'];
  allMeasures: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<File>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  measures?: Maybe<Array<MeasureMetadata>>;
  name: Scalars['String']['output'];
  resources?: Maybe<Array<ObjectiveStrategyTemplateResource>>;
  strategies?: Maybe<Array<ObjectiveStrategy>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type ObjectiveStrategyTemplateResource = {
  __typename?: 'ObjectiveStrategyTemplateResource';
  createdAt: Scalars['DateTime']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectiveStrategyTemplate: ObjectiveStrategyTemplate;
  objectiveStrategyTemplateId: Scalars['ID']['output'];
  updateAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ObjectiveTemplate = {
  __typename?: 'ObjectiveTemplate';
  cohortIds?: Maybe<Array<Scalars['Float']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  linkedStrategyTemplates?: Maybe<Array<ObjectiveStrategyTemplate>>;
  measures?: Maybe<Array<MeasureMetadata>>;
  /** Title of the objective template */
  name: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type OePipelineRun = {
  __typename?: 'OePipelineRun';
  auditourReports: Array<AuditourReport>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataflowRunUUID?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  etlRuns: Array<DataflowRun>;
  id: Scalars['String']['output'];
  inputSourcesListed?: Maybe<Scalars['Int']['output']>;
  inputSourcesResolved?: Maybe<Scalars['Int']['output']>;
  inputSourcesUnresolved?: Maybe<Scalars['Int']['output']>;
  inputTracking: InputTrackingStatus;
  inputTrackingAt?: Maybe<Scalars['DateTime']['output']>;
  inputTrackingError?: Maybe<Scalars['JSON']['output']>;
  inputs: Array<OeRunStatsInput>;
  movedToProd: MovedToProdStatus;
  movedToProdAt?: Maybe<Scalars['DateTime']['output']>;
  movedToStaging: MovedToProdStatus;
  startTime: Scalars['DateTime']['output'];
  status: DataflowRunStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  validation: DataflowValidationStatus;
};

export type OeRunStatsInput = {
  __typename?: 'OeRunStatsInput';
  DatasetName: Scalars['String']['output'];
  ETlRunuuid: Scalars['String']['output'];
  TenantName: Scalars['String']['output'];
};

export enum OpportunityType {
  Admin = 'Admin',
  Clinical = 'Clinical',
  DataQuality = 'DataQuality',
  Financial = 'Financial',
  Operational = 'Operational',
  PubliclyReported = 'PubliclyReported',
  StrategicGrowth = 'StrategicGrowth',
}

export type OrganizationalUnit = {
  __typename?: 'OrganizationalUnit';
  /** Every entry in the directory has a distinguished name (DN). The DN is the name that uniquely identifies an entry in the directory. It is a sequence of relative distinguished names (RDN) connected by commas. An RDN is an attribute with an associated value in the form attribute=value; normally expressed in a UTF-8 string format. RDN attributes consist of commonName (CN), organizationalUnitName (OU) and so on. */
  distinguishedName: Scalars['String']['output'];
  /** Sub Organizational Units */
  subOu?: Maybe<Array<OrganizationalUnit>>;
};

export type OtherEmail = {
  __typename?: 'OtherEmail';
  email: Scalars['String']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type OtherEmailInput = {
  email: Scalars['String']['input'];
};

export type OutboundMessageDetails = {
  __typename?: 'OutboundMessageDetails';
  body?: Maybe<Scalars['String']['output']>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  messageEvents?: Maybe<Array<OutboundMessageEvent>>;
  textBody?: Maybe<Scalars['String']['output']>;
};

export type OutboundMessageEvent = {
  __typename?: 'OutboundMessageEvent';
  details?: Maybe<OutboundMessageEventDetails>;
  receivedAt?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OutboundMessageEventDetails = {
  __typename?: 'OutboundMessageEventDetails';
  deliveryMessage?: Maybe<Scalars['String']['output']>;
  destinationIP?: Maybe<Scalars['String']['output']>;
  destinationServer?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type ParentChildValidation = {
  __typename?: 'ParentChildValidation';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  element: Element;
  id: Scalars['ID']['output'];
  parent: Element;
  parentElementSelectionName?: Maybe<Scalars['String']['output']>;
  parentId: Scalars['String']['output'];
  parentSelection?: Maybe<Selection>;
  parentSelectionId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

/** Role of the participant in the objective */
export enum ParticipantRole {
  Champion = 'CHAMPION',
  Sponsor = 'SPONSOR',
}

export type PasswordResetInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  /** Unique username */
  username: Scalars['String']['input'];
};

export type PatientListPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export enum PhiEnrichmentState {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS',
}

export type PipelineElement = {
  __typename?: 'PipelineElement';
  biomeDictionaryElements: Array<Element>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataframe: Scalars['String']['output'];
  denominatorMeasures?: Maybe<Array<MeasureMetadata>>;
  documentation?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  includeMeasures?: Maybe<Array<MeasureMetadata>>;
  numeratorMeasures?: Maybe<Array<MeasureMetadata>>;
  pipelineMetadata: PipelineMetadata;
  qualifiedName: Scalars['String']['output'];
  riskMetricMeasures?: Maybe<Array<MeasureMetadata>>;
  shortName: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
};

export type PipelineMetadata = {
  __typename?: 'PipelineMetadata';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  diseaseStateModule: DiseaseStateModule;
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  pipelineElements: Array<PipelineElement>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  version: Scalars['String']['output'];
};

export type PolicyRequest = {
  action: Scalars['String']['input'];
  attribute?: InputMaybe<Scalars['String']['input']>;
  dsmId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  object?: InputMaybe<Scalars['String']['input']>;
  objectType: EnforcerType;
  resource?: InputMaybe<Scalars['String']['input']>;
  /** roles/<roleId> */
  subjectId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  workbookGroupId?: InputMaybe<Scalars['String']['input']>;
  workbookId?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyResponse = {
  __typename?: 'PolicyResponse';
  action: Scalars['String']['output'];
  attribute?: Maybe<Scalars['String']['output']>;
  dsmId?: Maybe<Scalars['String']['output']>;
  eft?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  /** roles/<roleId> */
  subjectId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  workbookGroupId?: Maybe<Scalars['String']['output']>;
  workbookId?: Maybe<Scalars['String']['output']>;
};

export type Presentation = {
  __typename?: 'Presentation';
  clonedFor?: Maybe<Array<Scalars['String']['output']>>;
  clonesGenerated: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  cropConfig: Scalars['JSON']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imagesRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
  latestJob?: Maybe<Job>;
  latestJobId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  presentationType?: Maybe<PresentationType>;
  refreshJob?: Maybe<Job>;
  refreshJobId?: Maybe<Scalars['String']['output']>;
  slides?: Maybe<Array<Slide>>;
  submissions?: Maybe<PresentationSubmission>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type PresentationSubmission = {
  __typename?: 'PresentationSubmission';
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  presentation?: Maybe<Presentation>;
  presentationId: Scalars['String']['output'];
  quarter: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
};

export enum PresentationType {
  Adhoc = 'Adhoc',
  Etc = 'Etc',
  ExecutiveSummary = 'ExecutiveSummary',
  ProgrammaticSummary = 'ProgrammaticSummary',
  StrategicSummary = 'StrategicSummary',
}

export enum PublicationSource {
  HealthGrades = 'HealthGrades',
  HospitalCompare = 'HospitalCompare',
  NcdrClinicalMetricsGuide = 'NCDRClinicalMetricsGuide',
  StsStarRating = 'STSStarRating',
  Usnwr = 'USNWR',
}

export enum Quarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
}

export type Query = {
  __typename?: 'Query';
  activeApplicationNotice: ApplicationNotice;
  applicationNotice: ApplicationNotice;
  applicationNotices: Array<ApplicationNotice>;
  careEntities: Array<CareEntity>;
  careEntitiesCached: Array<CareEntity>;
  careEntitiesLive: Array<CareEntity>;
  careEntity: CareEntity;
  careEntityUpdateImpact: CareEntityUpdateImpact;
  checkApplicationNoticeConflict: ApplicationNotice;
  /** Checks if a resources is granted actions in Initiatives, Dashboards, General, Initiative or Clinician enforcer for the logged in user */
  checkPolicies: Array<PolicyResponse>;
  childrenCareEntities: Array<CareEntity>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModules: Array<DiseaseStateModule>;
  /** Returns the users carrying an explicit care-entity value - the exceptions to the tenant.code default used for the CARE_ENTITY segment of ingestion filenames - one page at a time; follow nextCursor until it is null to read them all. Empty until an admin sets one. Authorized by the existing ADMIN users.read permission, and filtered to the tenants the requester holds it in. */
  explicitCareEntityUsers: ExplicitCareEntityUserPage;
  /** returns users that have initiative (read) access on given entity / dsm within the requester's tenant i.e. PM (initiatives) application access and diseaseStateModule read access on given entity/dsm. doesn't include the root users */
  initiativeUsers: Array<User>;
  /** When the requester's care-entity/DSM permissions were last rebuilt. The table is materialised asynchronously, so views derived from it are only as fresh as this. Null when the requester has no permission rows. */
  lastCeDsmRefresh?: Maybe<Scalars['DateTime']['output']>;
  loginRoute: LoginRoute;
  loginRoutes: Array<LoginRoute>;
  /** Returns PolicyResponse[] (PolicyResponse is union type of all PolicyInput types) defined for give subjectId from given enforcer type */
  policies: Array<PolicyResponse>;
  role: Role;
  roles: Array<Role>;
  /** Returns all users associated with the requester’s active tenant or the tenant specified by tenantId */
  tenantUsers: Array<User>;
  urlMap: UrlMap;
  urlMaps: Array<UrlMap>;
  /** Returns user that matches id/username/email else returns loggedIn user */
  user: User;
  /** Returns a reduced audit view of users in the requester’s active tenant, with roles scoped to the requester’s care entities/DSMs */
  userAudit: Array<UserAudit>;
  userDiseaseStateModulesIds: Array<Scalars['Int']['output']>;
  /** Returns true if the user has set their initial password */
  userHasSetPassword: Scalars['Boolean']['output'];
  /** Returns all tables where given userId exists */
  userRelationshipTables: Array<Scalars['String']['output']>;
  /** Returns all enabled users associated with the given notification type */
  usersByNotificationType: Scalars['Float']['output'];
  /** Returns whether the email is valid, i.e. doesn't already exist in the db as a primary or other email for any user */
  validateEmail: Scalars['Boolean']['output'];
  /** Validate if requester is valid */
  validateUser: Scalars['Boolean']['output'];
  /** Returns whether the username is valid, i.e. doesn't already exist in the db or AD. */
  validateUsername: Scalars['Boolean']['output'];
  whoami: User;
};

export type QueryApplicationNoticeArgs = {
  id: Scalars['Float']['input'];
};

export type QueryCareEntitiesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCareEntitiesCachedArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCareEntitiesLiveArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryCareEntityArgs = {
  cmsId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCareEntityUpdateImpactArgs = {
  updateCareEntityInput: UpdateCareEntityInput;
};

export type QueryCheckApplicationNoticeConflictArgs = {
  input: CheckApplicationNoticeConflictInput;
};

export type QueryCheckPoliciesArgs = {
  policyInputs: Array<PolicyRequest>;
};

export type QueryChildrenCareEntitiesArgs = {
  code: Scalars['String']['input'];
};

export type QueryDiseaseStateModuleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDiseaseStateModulesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryExplicitCareEntityUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInitiativeUsersArgs = {
  dsmId: Scalars['Int']['input'];
  entityId: Scalars['String']['input'];
};

export type QueryLoginRouteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLoginRoutesArgs = {
  identityProvider?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPoliciesArgs = {
  enforcerType: Scalars['String']['input'];
  subjects: Array<Scalars['String']['input']>;
};

export type QueryRoleArgs = {
  id: Scalars['String']['input'];
};

export type QueryRolesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryTenantUsersArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUrlMapArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserHasSetPasswordArgs = {
  email: Scalars['String']['input'];
};

export type QueryUserRelationshipTablesArgs = {
  userId: Scalars['String']['input'];
};

export type QueryUsersByNotificationTypeArgs = {
  notificationType: NotificationType;
};

export type QueryValidateEmailArgs = {
  email: Scalars['String']['input'];
};

export type QueryValidateUsernameArgs = {
  username: Scalars['String']['input'];
};

export type Range = {
  __typename?: 'Range';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  element: Element;
  id: Scalars['ID']['output'];
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  usualRangeMax?: Maybe<Scalars['Float']['output']>;
  usualRangeMin?: Maybe<Scalars['Float']['output']>;
  validRangeMax?: Maybe<Scalars['Float']['output']>;
  validRangeMin?: Maybe<Scalars['Float']['output']>;
};

export type RecentTableauView = {
  __typename?: 'RecentTableauView';
  /** Unique id for this recent tableau view */
  id: Scalars['ID']['output'];
  /** Tableau view the user visited */
  tableauView: TableauView;
  /** Tenant the dashboard was viewed in */
  tenant: Tenant;
  /** Tenant the dashboard was viewed in */
  tenantId: Scalars['String']['output'];
  /** The date the user visited the dashboard */
  viewedAt: Scalars['DateTime']['output'];
  /** User who visited the dashboard */
  viewedBy: User;
};

export type ReminderLog = {
  __typename?: 'ReminderLog';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  followUpDisabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  month?: Maybe<Month>;
  quarter?: Maybe<Quarter>;
  submission: Submission;
  submissionId: Scalars['String']['output'];
  type: ReminderTrigger;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export enum ReminderTrigger {
  Automated = 'Automated',
  AutomatedFollowUp = 'AutomatedFollowUp',
  Manual = 'Manual',
}

export type Report = {
  __typename?: 'Report';
  /** Creation Datetime */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dateColumn: Scalars['String']['output'];
  dateRangeType?: Maybe<DateRangeTypes>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dimensions?: Maybe<Array<Dimension>>;
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  distributionLists?: Maybe<Array<DistributionList>>;
  endDate?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  id: Scalars['ID']['output'];
  measures?: Maybe<Array<MeasureMetadata>>;
  name: Scalars['String']['output'];
  procedures?: Maybe<Array<Scalars['String']['output']>>;
  quarters?: Maybe<Array<Scalars['String']['output']>>;
  registryElements?: Maybe<Array<Element>>;
  startDate?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  /** Modification Datetime */
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export enum RequestMethod {
  Both = 'Both',
  Get = 'Get',
  Post = 'Post',
}

export type RequiredPolicy = {
  __typename?: 'RequiredPolicy';
  action: Action;
  attribute?: Maybe<Scalars['String']['output']>;
  dsmId?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  objectType: EnforcerType;
  resource?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  workbookGroupId?: Maybe<Scalars['String']['output']>;
  workbookId?: Maybe<Scalars['String']['output']>;
};

export enum ResponseType {
  PermanentRedirect = 'PermanentRedirect',
  TemporaryRedirect = 'TemporaryRedirect',
}

export type RiskAudit = {
  __typename?: 'RiskAudit';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  auditFlagSource?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeETLVersion?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  diagnosisPOACodeList?: Maybe<Scalars['String']['output']>;
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  dischargeQuarter?: Maybe<Scalars['String']['output']>;
  dischargeYear?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['String']['output']>;
  etlRefresh?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<FlagType>;
  hospital?: Maybe<Scalars['String']['output']>;
  icd10TriggerCode?: Maybe<Scalars['String']['output']>;
  keyField?: Maybe<Scalars['String']['output']>;
  keyFieldValue?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mrnOriginal?: Maybe<Scalars['String']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciStatus?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  reviewTriggerDescription?: Maybe<Scalars['String']['output']>;
  riskReview?: Maybe<Scalars['String']['output']>;
  riskValue?: Maybe<Scalars['String']['output']>;
  surgicalQuarter?: Maybe<Scalars['String']['output']>;
  surgicalYear?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails: Array<RiskAuditTrail>;
  visitId?: Maybe<Scalars['Float']['output']>;
  visitTiming?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type RiskAuditField = {
  __typename?: 'RiskAuditField';
  category: RiskAuditFieldCategory;
  common: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  displayRank: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phi: Scalars['Boolean']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  visibility: VisibilityType;
};

export enum RiskAuditFieldCategory {
  Biome = 'BIOME',
  PatientStudyDemographics = 'PATIENT_STUDY_DEMOGRAPHICS',
  RiskAuditVariables = 'RISK_AUDIT_VARIABLES',
}

export type RiskAuditTrail = {
  __typename?: 'RiskAuditTrail';
  auditTask?: Maybe<RiskAudit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum RiskAuditTrailStatus {
  ReviewAcceptedAndUpdated = 'ReviewAcceptedAndUpdated',
  ReviewRejected = 'ReviewRejected',
  ReviewRequired = 'ReviewRequired',
}

export type RiskMetric = {
  __typename?: 'RiskMetric';
  columnName: Scalars['String']['output'];
  developmentMeasures?: Maybe<Array<DevelopmentMeasure>>;
  diseaseStateModule: DiseaseStateModule;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  measureMetadatas?: Maybe<Array<MeasureMetadata>>;
};

export type RiskMetricDeletionActionInput = {
  replacementRiskMetricId?: InputMaybe<Scalars['ID']['input']>;
  riskMetricId: Scalars['ID']['input'];
};

export type RoiMetric = {
  __typename?: 'RoiMetric';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  fieldName: Scalars['String']['output'];
  higherIsBetter: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  legacyDescription?: Maybe<Scalars['String']['output']>;
  pipelineElement?: Maybe<PipelineElement>;
  pipelineElementId?: Maybe<Scalars['String']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  __typename?: 'Role';
  careEntities?: Maybe<Array<CareEntity>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModules?: Maybe<Array<DiseaseStateModule>>;
  id: Scalars['ID']['output'];
  identityProviders: Array<IdentityProvider>;
  jobs?: Maybe<Array<Job>>;
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  type: RoleType;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export enum RoleType {
  AdminConsoleReporting = 'ADMIN_CONSOLE_REPORTING',
  BiomePk = 'BIOME_PK',
  BiomeUs = 'BIOME_US',
  Collaborator = 'COLLABORATOR',
  Custom = 'CUSTOM',
  EchoSurveillanceModerator = 'ECHO_SURVEILLANCE_MODERATOR',
  EchoSurveillant = 'ECHO_SURVEILLANT',
  SuperUser = 'SUPER_USER',
  TenantAdmin = 'TENANT_ADMIN',
  WorkflowAuthorizationSpecialist = 'WORKFLOW_AUTHORIZATION_SPECIALIST',
  WorkflowCareCoordinator = 'WORKFLOW_CARE_COORDINATOR',
  WorkflowClinicalLead = 'WORKFLOW_CLINICAL_LEAD',
  WorkflowReportingViewer = 'WORKFLOW_REPORTING_VIEWER',
}

export type Section = {
  __typename?: 'Section';
  cardinality: CardinalityType;
  children?: Maybe<Array<Section>>;
  containerClass?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dictionary: Dictionary;
  dictionaryId: Scalars['String']['output'];
  elements?: Maybe<Array<Element>>;
  hideFromReports: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  parent?: Maybe<Section>;
  parentId?: Maybe<Scalars['ID']['output']>;
  sectionCode: Scalars['String']['output'];
  sectionDisplayName: Scalars['String']['output'];
  sectionType: SectionType;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type SectionInput = {
  id: Scalars['ID']['input'];
};

export enum SectionType {
  RepeatSection = 'RepeatSection',
  Section = 'Section',
}

export type Selection = {
  __typename?: 'Selection';
  code?: Maybe<Scalars['String']['output']>;
  codeSystem?: Maybe<Scalars['String']['output']>;
  codeSystemName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  element: Element;
  id: Scalars['ID']['output'];
  parentChildValidations?: Maybe<Array<ParentChildValidation>>;
  selectionDefinition?: Maybe<Scalars['String']['output']>;
  selectionName: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type Slide = {
  __typename?: 'Slide';
  configuredDashboard?: Maybe<TableauView>;
  configuredDashboardId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  defaultCropConfig: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  imageConfig?: Maybe<SlideImageConfig>;
  imageFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  imageStatus: SlideImageStatus;
  isNative?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  presentation: Presentation;
  presentationId: Scalars['String']['output'];
  shareableLink?: Maybe<Scalars['String']['output']>;
  slideType: SlideType;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export type SlideImageConfig = {
  __typename?: 'SlideImageConfig';
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export enum SlideImageStatus {
  NonApplicable = 'NonApplicable',
  PendingRefresh = 'PendingRefresh',
  Ready = 'Ready',
  RefreshFailed = 'RefreshFailed',
  Unavailable = 'Unavailable',
}

export enum SlideType {
  Compass = 'Compass',
  Dashboard = 'Dashboard',
  Echo = 'Echo',
  InitiativeDetail = 'InitiativeDetail',
  Kb = 'Kb',
  Oe = 'Oe',
  Placeholder = 'Placeholder',
  Pm = 'Pm',
  RiskAudit = 'RiskAudit',
  Section = 'Section',
  VariationAndBenchmarking = 'VariationAndBenchmarking',
}

export enum SortType {
  Alphabetical = 'ALPHABETICAL',
  BiomeSpecified = 'BIOME_SPECIFIED',
  Custom = 'CUSTOM',
  MetricPerformance = 'METRIC_PERFORMANCE',
  QualifyingCases = 'QUALIFYING_CASES',
}

export type StrategyBoardPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dsmId: Scalars['String']['input'];
  eft?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type StrategyParticipant = {
  __typename?: 'StrategyParticipant';
  createdAt: Scalars['DateTime']['output'];
  /** Free text username/email for external participants not in User table */
  externalUsername?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role: ParticipantRole;
  strategy: ObjectiveStrategy;
  strategyId: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type StsAudit = {
  __typename?: 'StsAudit';
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  auditFlagSource?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeETLVersion?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  diagnosisPOACodeList?: Maybe<Scalars['String']['output']>;
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  dischargeQuarter?: Maybe<Scalars['String']['output']>;
  dischargeYear?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['String']['output']>;
  etlRefresh?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<FlagType>;
  hospital?: Maybe<Scalars['String']['output']>;
  icd10TriggerCode?: Maybe<Scalars['String']['output']>;
  keyField?: Maybe<Scalars['String']['output']>;
  keyFieldValue?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mrnOriginal?: Maybe<Scalars['String']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciStatus?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  reviewTriggerDescription?: Maybe<Scalars['String']['output']>;
  riskReview?: Maybe<Scalars['String']['output']>;
  riskValue?: Maybe<Scalars['String']['output']>;
  surgicalQuarter?: Maybe<Scalars['String']['output']>;
  surgicalYear?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails: Array<StsAuditTrail>;
  visitId?: Maybe<Scalars['Float']['output']>;
  visitTiming?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type StsAuditTrail = {
  __typename?: 'StsAuditTrail';
  auditTask?: Maybe<StsAudit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type Submission = {
  __typename?: 'Submission';
  aggregate: Scalars['Boolean']['output'];
  beats?: Maybe<Array<Beat>>;
  cadence: Scalars['String']['output'];
  careEntity: CareEntity;
  careEntityId: Scalars['String']['output'];
  ccEmails?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Submission>>;
  clientDataFiles?: Maybe<Array<ClientDataFile>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataset: Dataset;
  datasetId: Scalars['Int']['output'];
  daysAfterDeadline: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mrnCrosswalkRequired: Scalars['Boolean']['output'];
  mrnHarvestRequired: Scalars['Boolean']['output'];
  parent?: Maybe<Submission>;
  parentId?: Maybe<Scalars['String']['output']>;
  reminderLogs?: Maybe<Array<ReminderLog>>;
  sendReminders: Scalars['Boolean']['output'];
  submitNationalReport: Scalars['Boolean']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SubmissionInput = {
  id: Scalars['ID']['input'];
};

export enum SummaryCalculationType {
  Annualized = 'Annualized',
  Custom = 'Custom',
  Standard = 'Standard',
}

export type SupportEmail = {
  __typename?: 'SupportEmail';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issueKey?: Maybe<Scalars['String']['output']>;
};

export enum SupportedApps {
  Ae = 'AE',
  Echo = 'ECHO',
  Oe = 'OE',
  Pm = 'PM',
  Reportbuilder = 'REPORTBUILDER',
  Riskaudit = 'RISKAUDIT',
}

export type TableauView = {
  __typename?: 'TableauView';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primaryMeasureIds?: Maybe<Array<Scalars['Int']['output']>>;
  recentTableauViews?: Maybe<Array<RecentTableauView>>;
  renderInMenu: Scalars['Boolean']['output'];
  secondaryMeasureIds?: Maybe<Array<Scalars['Int']['output']>>;
  slides?: Maybe<Array<Slide>>;
  sortOrder: Scalars['Float']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  workbook: Workbook;
  workbookId: Scalars['Float']['output'];
};

export enum Tags {
  Clinical = 'Clinical',
  Financial = 'Financial',
  Phi = 'Phi',
}

export type TavrAudit = {
  __typename?: 'TavrAudit';
  DRGCode?: Maybe<Scalars['String']['output']>;
  arrivalDate?: Maybe<Scalars['DateTime']['output']>;
  auditFlagSource?: Maybe<Scalars['String']['output']>;
  auditId: Scalars['Float']['output'];
  biomeETLVersion?: Maybe<Scalars['String']['output']>;
  biomeEncounterId: Scalars['Float']['output'];
  biomeUpdateDt?: Maybe<Scalars['DateTime']['output']>;
  careEntity?: Maybe<CareEntity>;
  careEntityId?: Maybe<Scalars['String']['output']>;
  careEntityName?: Maybe<Scalars['String']['output']>;
  diagnosisPOACodeList?: Maybe<Scalars['String']['output']>;
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  dischargeQuarter?: Maybe<Scalars['String']['output']>;
  dischargeYear?: Maybe<Scalars['String']['output']>;
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId?: Maybe<Scalars['String']['output']>;
  drgCode?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['String']['output']>;
  etlRefresh?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<FlagType>;
  hospital?: Maybe<Scalars['String']['output']>;
  icd10TriggerCode?: Maybe<Scalars['String']['output']>;
  keyField?: Maybe<Scalars['String']['output']>;
  keyFieldValue?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  mrnOriginal?: Maybe<Scalars['String']['output']>;
  pciIndication?: Maybe<Scalars['String']['output']>;
  pciStatus?: Maybe<Scalars['String']['output']>;
  physician?: Maybe<Scalars['String']['output']>;
  procedure?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['DateTime']['output']>;
  procedureGroup?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registryId?: Maybe<Scalars['String']['output']>;
  reviewTriggerDescription?: Maybe<Scalars['String']['output']>;
  riskReview?: Maybe<Scalars['String']['output']>;
  riskValue?: Maybe<Scalars['String']['output']>;
  surgicalQuarter?: Maybe<Scalars['String']['output']>;
  surgicalYear?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trails: Array<TavrAuditTrail>;
  visitId?: Maybe<Scalars['Float']['output']>;
  visitTiming?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type TavrAuditTrail = {
  __typename?: 'TavrAuditTrail';
  auditTask?: Maybe<TavrAudit>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  latestStudyOnRecord: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  /** Tracks the status of audit trail */
  status: RiskAuditTrailStatus;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Tenant/Client */
export type Tenant = {
  __typename?: 'Tenant';
  active: Scalars['Boolean']['output'];
  aggregationTenant: Scalars['Boolean']['output'];
  applicationNotices?: Maybe<Array<ApplicationNotice>>;
  banner?: Maybe<File>;
  careEntities?: Maybe<Array<CareEntity>>;
  /** Schema name where audit, echo and cases data is available for tenant. If null, defaults to <tenantCode>_cases */
  casesSchema?: Maybe<Scalars['String']['output']>;
  clinicalOnly: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  contractedDisplayPHI: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deliverableBlinded: Scalars['Boolean']['output'];
  dictionaries?: Maybe<Array<Dictionary>>;
  disableBiomedataLogin: Scalars['Boolean']['output'];
  disableHomepage: Scalars['Boolean']['output'];
  distributionLists?: Maybe<Array<DistributionList>>;
  documents?: Maybe<Array<File>>;
  echoFindingFields?: Maybe<Array<EchoFindingField>>;
  echoFollowupOptions?: Maybe<Array<EchoFindingFollowupOption>>;
  echoModules?: Maybe<Array<EchoFindingModule>>;
  encryptionKeys?: Maybe<Array<Scalars['String']['output']>>;
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  identityProvider?: Maybe<IdentityProvider>;
  /** IT contact email for the tenant. */
  itContact?: Maybe<Scalars['String']['output']>;
  jobs?: Maybe<Array<Job>>;
  logo?: Maybe<File>;
  name: Scalars['String']['output'];
  objectives?: Maybe<Array<Objective>>;
  organizationalUnit?: Maybe<Scalars['String']['output']>;
  presentations?: Maybe<Array<Presentation>>;
  projectSponsor?: Maybe<User>;
  projectSponsorId?: Maybe<Scalars['String']['output']>;
  riskAuditFields?: Maybe<Array<RiskAuditField>>;
  roles?: Maybe<Array<Role>>;
  rollupMode?: Maybe<AggregationRollupMode>;
  /** Restrict this tenant to a specific subdomain alias. */
  subdomain?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use clinicalOnly, which is this flag inverted. */
  submitsCostData: Scalars['Boolean']['output'];
  tokens?: Maybe<Array<Token>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
  usesAnubisUpload: Scalars['Boolean']['output'];
  /** Workbooks the tenant sees, with all of their dashboards */
  workbooks?: Maybe<Array<Workbook>>;
};

export type TenantPolicyInput = {
  action: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type Thread = {
  __typename?: 'Thread';
  comments: Array<Comment>;
  /** Total number of comments in this thread */
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  /** Thread description */
  description?: Maybe<Scalars['String']['output']>;
  /** Generic entity ID this thread belongs to */
  entityId: Scalars['String']['output'];
  /** Generic entity type this thread belongs to */
  entityType: Scalars['String']['output'];
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  /** Whether thread is locked (no editing allowed) */
  isLocked: Scalars['Boolean']['output'];
  /** Whether thread is private (internal only) */
  isPrivate: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  /** Thread title/name */
  title: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById?: Maybe<Scalars['String']['output']>;
};

/** JWT Token */
export type Token = {
  __typename?: 'Token';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  /** uuid as primary key */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revokedAt: Scalars['DateTime']['output'];
  status: TokenStatus;
  subject: User;
  subjectId: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  /** JWT Token in hash format */
  token: Scalars['String']['output'];
  type: TokenType;
  updateAt: Scalars['DateTime']['output'];
};

export enum TokenStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
}

export enum TokenType {
  Access = 'ACCESS',
  Email = 'EMAIL',
  Impersonate = 'IMPERSONATE',
  Longliving = 'LONGLIVING',
  PasswordChange = 'PASSWORD_CHANGE',
  Refresh = 'REFRESH',
}

export type Transformation = {
  __typename?: 'Transformation';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  delimiter?: Maybe<Scalars['String']['output']>;
  derivative?: Maybe<Element>;
  derivativeCode?: Maybe<Scalars['String']['output']>;
  derivativeId?: Maybe<Scalars['String']['output']>;
  derivativeValue?: Maybe<Scalars['String']['output']>;
  derivativeValueCode?: Maybe<Scalars['String']['output']>;
  exactMatch?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<Element>;
  referenceCode: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  translation: Translation;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  valueMap?: Maybe<Scalars['JSON']['output']>;
};

export type Translation = {
  __typename?: 'Translation';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source?: Maybe<Element>;
  sourceId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Element>;
  targetId?: Maybe<Scalars['String']['output']>;
  transformation?: Maybe<Transformation>;
  transformationId?: Maybe<Scalars['String']['output']>;
  translatorConfig: TranslatorConfig;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  valueMap?: Maybe<Scalars['JSON']['output']>;
};

export type TranslatorConfig = {
  __typename?: 'TranslatorConfig';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  dataFeed?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  source: Dictionary;
  target: Dictionary;
  translations: Array<Translation>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum TriggerGranularity {
  PerDsm = 'PerDsm',
  PerPipeline = 'PerPipeline',
}

export type TriggerablePipeline = {
  __typename?: 'TriggerablePipeline';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  pipelineName: Scalars['String']['output'];
  pipelineType: DagsterTriggerPipelineType;
  supportedDsms?: Maybe<Array<DiseaseStateModule>>;
  triggerGranularity: TriggerGranularity;
  triggers?: Maybe<Array<DagsterTrigger>>;
  updateAt: Scalars['DateTime']['output'];
};

export type UpdateApplicationNoticeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  downtime?: InputMaybe<Scalars['Boolean']['input']>;
  downtimeDescription?: InputMaybe<Scalars['String']['input']>;
  downtimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  downtimeName?: InputMaybe<Scalars['String']['input']>;
  downtimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  downtimeTitle?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateCareEntityInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aggregated?: InputMaybe<Scalars['Boolean']['input']>;
  alternateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  anonymousCode?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<UpdateCareEntityInput>>;
  city?: InputMaybe<Scalars['String']['input']>;
  cmsId?: InputMaybe<Scalars['String']['input']>;
  cmsIdNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  datasets?: InputMaybe<Array<UpdateDatasetInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModules?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  /** DSMs this care entity participates in but neither reviews nor pushes. Absent leaves existing exclusions untouched; empty clears them; present is authoritative. */
  excludedDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  id: Scalars['ID']['input'];
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceMonth?: InputMaybe<Scalars['Int']['input']>;
  isEngagementEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Per-member DSM scoping for this aggregate. Absent leaves scoping untouched; present is authoritative for this parent. Ignored on a nested child input. */
  memberDsms?: InputMaybe<Array<CareEntityMemberDsmInput>>;
  monthlySponsorTouchbase?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noOfBeds?: InputMaybe<Scalars['Int']['input']>;
  onboardingCompletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  parents?: InputMaybe<Array<UpdateCareEntityInput>>;
  physicianChampion?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<Scalars['String']['input']>;
  pushOnlyDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  reasonForNoCmsId?: InputMaybe<Scalars['String']['input']>;
  reviewDsms?: InputMaybe<Array<UpdateDiseaseStateModuleInput>>;
  shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<Array<SubmissionInput>>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  teaching?: InputMaybe<Scalars['Boolean']['input']>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  type?: InputMaybe<CareEntityType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usGeoRegion?: InputMaybe<UsGeoRegion>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClinicalProgramInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateDatasetInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  crosswalkRequired?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isCrosswalkSource?: InputMaybe<Scalars['Boolean']['input']>;
  isDropAndLoad?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistry?: InputMaybe<Scalars['Boolean']['input']>;
  isTenantLevel?: InputMaybe<Scalars['Boolean']['input']>;
  managingSociety?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the dataset supports the report builder feature. */
  supportsReportBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateDictionaryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataFeed?: InputMaybe<CreateDictionaryInput>;
  dataset?: InputMaybe<UpdateDatasetInput>;
  feedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  sections?: InputMaybe<Array<CreateSectionInput>>;
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  type?: InputMaybe<DictionaryType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDimensionInput = {
  aeQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  allMeasures?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionValueSortOrder?: InputMaybe<
    Array<UpdateNestedDimensionValueSortOrderInput>
  >;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  excludeValues?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  multiProcTableId?: InputMaybe<Scalars['String']['input']>;
  oeQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortType>;
  sourceContinuousField?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DimensionType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueMap?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateDiseaseStateModuleInput = {
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  clinicalProgram?: InputMaybe<UpdateClinicalProgramInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  criticalDatasets?: InputMaybe<Array<UpdateDatasetInput>>;
  datasets?: InputMaybe<Array<UpdateDatasetInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  hideRiskAuditCharts?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  multiProcTableDeletionActions?: InputMaybe<
    Array<MultiProcTableDeletionActionInput>
  >;
  multiProcTables?: InputMaybe<Array<DiseaseStateModuleMultiProcTableInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryDataset?: InputMaybe<UpdateDatasetInput>;
  riskMetricDeletionActions?: InputMaybe<Array<RiskMetricDeletionActionInput>>;
  riskMetrics?: InputMaybe<Array<DiseaseStateModuleRiskMetricInput>>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  supportedApps?: InputMaybe<Array<SupportedApps>>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateDistributionListInput = {
  allowedFiles?: InputMaybe<Array<UpdateFileInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateEchoModuleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayRank?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateElementInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeSystemName?: InputMaybe<Scalars['String']['input']>;
  codingInstructions?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataSource?: InputMaybe<ElementDataSourceType>;
  dataType?: InputMaybe<ElementDataType>;
  dbDataType?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<CreateDefinitionInput>;
  elementReference?: InputMaybe<Scalars['String']['input']>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isBaseElement?: InputMaybe<Scalars['Boolean']['input']>;
  isDynamicList?: InputMaybe<Scalars['Boolean']['input']>;
  isFollowupElement?: InputMaybe<Scalars['Boolean']['input']>;
  isHarvested?: InputMaybe<Scalars['Boolean']['input']>;
  isIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
  missingData?: InputMaybe<ElementMissingDataAction>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentChildValidations?: InputMaybe<Array<CreateParentChildValidationInput>>;
  phi?: InputMaybe<Scalars['Boolean']['input']>;
  precision?: InputMaybe<Scalars['String']['input']>;
  ranges?: InputMaybe<Array<CreateRangeInput>>;
  role?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<UpdateSectionInput>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  selectionType?: InputMaybe<ElementSelectionType>;
  selections?: InputMaybe<Array<CreateSelectionInput>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  targetValue?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  vendorInstruction?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFileInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  extension?: InputMaybe<Scalars['String']['input']>;
  fileLabel?: InputMaybe<UpdateFileLabelInput>;
  fileUsers?: InputMaybe<Array<FileUserInput>>;
  historicPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  phi?: InputMaybe<Scalars['Boolean']['input']>;
  report?: InputMaybe<UpdateReportInput>;
  reportId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateById?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateFileLabelInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  files?: InputMaybe<Array<FileInput>>;
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateIdentityProviderInput = {
  authnContext?: InputMaybe<Scalars['String']['input']>;
  certificate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  defaultRoles?: InputMaybe<Array<UpdateRoleInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute?: InputMaybe<Scalars['String']['input']>;
  forceAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  groupAccessType?: InputMaybe<IdentityProviderGroupAccessType>;
  id: Scalars['ID']['input'];
  identifierFormat?: InputMaybe<Scalars['String']['input']>;
  lastNameAttribute?: InputMaybe<Scalars['String']['input']>;
  logoutUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provisionUsers?: InputMaybe<Scalars['Boolean']['input']>;
  securityGroup?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  updateUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLoginRouteInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  identityProvider?: InputMaybe<UpdateIdentityProviderInput>;
};

export type UpdateMeasureMetadataInput = {
  accessCategory?: InputMaybe<AccessCategory>;
  adjustment?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationFn?: InputMaybe<Array<Scalars['String']['input']>>;
  aggregationType?: InputMaybe<SummaryCalculationType>;
  annualMeasureBaseId?: InputMaybe<Scalars['String']['input']>;
  benchmarkExtraction?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  commonMeasureDisplayName?: InputMaybe<Scalars['String']['input']>;
  commonMeasureQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  costComponentMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataTypeRequired?: InputMaybe<MeasureInputDataType>;
  denominatorColumnName?: InputMaybe<Scalars['String']['input']>;
  denominatorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  developedOn?: InputMaybe<Scalars['DateTime']['input']>;
  dimensionSets?: InputMaybe<Array<CreateNestedDimensionSetInput>>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  excludedCohortIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  higherIsBetter?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  includeColumnName?: InputMaybe<Scalars['String']['input']>;
  includePipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  isBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  losROIQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncdrMeasureName?: InputMaybe<Scalars['String']['input']>;
  numeratorColumnName?: InputMaybe<Scalars['String']['input']>;
  numeratorPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  numeratorUnit?: InputMaybe<Scalars['String']['input']>;
  objects?: InputMaybe<Array<CreateObjectMeasureInput>>;
  opportunityType?: InputMaybe<Array<OpportunityType>>;
  outcomeType?: InputMaybe<MeasureOutcomeType>;
  parent?: InputMaybe<UpdateMeasureMetadataInput>;
  publicationSource?: InputMaybe<Array<PublicationSource>>;
  rareEvent?: InputMaybe<Scalars['Boolean']['input']>;
  registryMeasureId?: InputMaybe<Scalars['Int']['input']>;
  reportRowId?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  riskAdjusted?: InputMaybe<Scalars['Boolean']['input']>;
  riskMetricId?: InputMaybe<Scalars['String']['input']>;
  riskMetricPipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  roiCalcType?: InputMaybe<SummaryCalculationType>;
  roiMetrics?: InputMaybe<Array<UpdateRoiMetricInput>>;
  subjects?: InputMaybe<Array<CreateSubjectMeasureInput>>;
  summaryCohortId?: InputMaybe<Scalars['Float']['input']>;
  summaryInitiativeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  tableauViews?: InputMaybe<Array<CreateMeasureTableauViewInput>>;
  testCapture?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  validationSource?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  volumeMeasure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNestedDimensionValueSortOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sortOrder: Scalars['Int']['input'];
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  valueLabel: Scalars['String']['input'];
};

export type UpdateNotificationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdatePipelineElementInput = {
  biomeDictionaryElements?: InputMaybe<Array<UpdateElementInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataframe?: InputMaybe<Scalars['String']['input']>;
  documentation?: InputMaybe<Documentation>;
  id: Scalars['ID']['input'];
  pipelineMetadata?: InputMaybe<UpdatePipelineMetadataInput>;
  qualifiedName?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdatePipelineMetadataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  id: Scalars['ID']['input'];
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  pipelineElements?: InputMaybe<Array<UpdatePipelineElementInput>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dateColumn?: InputMaybe<Scalars['String']['input']>;
  dateRangeType?: InputMaybe<DateRangeTypes>;
  dimensions?: InputMaybe<Array<UpdateDimensionInput>>;
  diseaseStateModuleId?: InputMaybe<Scalars['Int']['input']>;
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  measures?: InputMaybe<Array<UpdateMeasureMetadataInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  procedures?: InputMaybe<Array<Scalars['String']['input']>>;
  quarters?: InputMaybe<Array<Scalars['String']['input']>>;
  registryElements?: InputMaybe<Array<UpdateElementInput>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateRoiMetricInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  higherIsBetter?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  legacyDescription?: InputMaybe<Scalars['String']['input']>;
  pipelineElement?: InputMaybe<UpdatePipelineElementInput>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateRoleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tenant: UpdateTenantInput;
  type?: InputMaybe<RoleType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  users?: InputMaybe<Array<UpdateUserInput>>;
};

export type UpdateSectionInput = {
  cardinality?: InputMaybe<CardinalityType>;
  containerClass?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dictionary?: InputMaybe<UpdateDictionaryInput>;
  elements?: InputMaybe<Array<CreateElementInput>>;
  hideFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  parent?: InputMaybe<SectionInput>;
  parentSection?: InputMaybe<Scalars['String']['input']>;
  sectionCode?: InputMaybe<Scalars['String']['input']>;
  sectionDisplayName?: InputMaybe<Scalars['String']['input']>;
  sectionType?: InputMaybe<SectionType>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateSelectionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  codeSystem?: InputMaybe<Scalars['String']['input']>;
  codeSystemName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  element?: InputMaybe<UpdateElementInput>;
  id: Scalars['ID']['input'];
  selectionDefinition?: InputMaybe<Scalars['String']['input']>;
  selectionName?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateSubmissionInput = {
  aggregate?: InputMaybe<Scalars['Boolean']['input']>;
  cadence?: InputMaybe<Scalars['String']['input']>;
  careEntity?: InputMaybe<UpdateCareEntityInput>;
  ccEmails?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<UpdateSubmissionInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  dataset?: InputMaybe<UpdateDatasetInput>;
  daysAfterDeadline?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mrnCrosswalkRequired?: InputMaybe<Scalars['Boolean']['input']>;
  mrnHarvestRequired?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  submitNationalReport?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  user?: InputMaybe<UpdateUserInput>;
};

export type UpdateTenantInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  aggregationTenant?: InputMaybe<Scalars['Boolean']['input']>;
  banner?: InputMaybe<FileInput>;
  careEntities?: InputMaybe<Array<UpdateCareEntityInput>>;
  casesSchema?: InputMaybe<Scalars['String']['input']>;
  clinicalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  contractedDisplayPHI?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  deliverableBlinded?: InputMaybe<Scalars['Boolean']['input']>;
  disableBiomedataLogin?: InputMaybe<Scalars['Boolean']['input']>;
  disableHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Array<FileInput>>;
  echoModules?: InputMaybe<Array<UpdateEchoModuleInput>>;
  encryptionKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  /** IT contact email for the tenant. */
  itContact?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationalUnit?: InputMaybe<Scalars['String']['input']>;
  projectSponsor?: InputMaybe<UpdateUserInput>;
  projectSponsorId?: InputMaybe<Scalars['String']['input']>;
  rollupMode?: InputMaybe<AggregationRollupMode>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  usesAnubisUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Replaces the workbooks the tenant sees */
  workbooks?: InputMaybe<Array<UpdateWorkbookInput>>;
};

export type UpdateUrlMapInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  destination?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  method?: InputMaybe<RequestMethod>;
  responseType?: InputMaybe<ResponseType>;
  source?: InputMaybe<Scalars['String']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
};

export type UpdateUserAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Array<UpdateNotificationInput>>;
  otherEmails?: InputMaybe<Array<OtherEmailInput>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  adGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedFiles?: InputMaybe<Array<UpdateFileInput>>;
  careEntityCode?: InputMaybe<Scalars['String']['input']>;
  ccOnboardingEmail?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<CreateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableBiomedataLogin?: InputMaybe<Scalars['Boolean']['input']>;
  distributionLists?: InputMaybe<Array<UpdateDistributionListInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableSftp?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time when the user was enabled. This is used to keep certain items on the UI disabled until this change is synced to Azure AD. */
  enabledTime?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homepage?: InputMaybe<CreateBookmarkInput>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Array<UpdateNotificationInput>>;
  organizationalUnit?: InputMaybe<Scalars['String']['input']>;
  otherEmails?: InputMaybe<Array<OtherEmailInput>>;
  passwordNeverExpires?: InputMaybe<Scalars['Boolean']['input']>;
  permanentAccount?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UpdateRoleInput>>;
  root?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<UserStatus>;
  submissions?: InputMaybe<Array<UpdateSubmissionInput>>;
  submitsData?: InputMaybe<Scalars['Boolean']['input']>;
  tenant?: InputMaybe<UpdateTenantInput>;
  tenantPolicies?: InputMaybe<Array<TenantPolicyInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  twoFactor?: InputMaybe<Scalars['Boolean']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  /** Unique username */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkbookGroupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  renderAsLink?: InputMaybe<Scalars['Boolean']['input']>;
  renderInMenu?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  workbooks?: InputMaybe<Array<UpdateWorkbookInput>>;
};

export type UpdateWorkbookInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UpdateUserInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  diseaseStateModule?: InputMaybe<UpdateDiseaseStateModuleInput>;
  id: Scalars['Int']['input'];
  measureIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  tableauUri?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Tags>>;
  /** Active tenants that see this workbook and its dashboards; links to disabled tenants are left unchanged. */
  tenants?: InputMaybe<Array<UpdateTenantInput>>;
  updateAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateBy?: InputMaybe<UpdateUserInput>;
  workbookGroup?: InputMaybe<UpdateWorkbookGroupInput>;
};

export type UrlMap = {
  __typename?: 'UrlMap';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  destination: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  method: RequestMethod;
  priority: Scalars['Int']['output'];
  responseType: ResponseType;
  source: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
};

export enum UsGeoRegion {
  Canada = 'Canada',
  EastSouthCentral = 'EastSouthCentral',
  GreatLakes = 'GreatLakes',
  GreatPlains = 'GreatPlains',
  MiddleAtlantic = 'MiddleAtlantic',
  Mountain = 'Mountain',
  NewEngland = 'NewEngland',
  Pacific = 'Pacific',
  SouthAtlantic = 'SouthAtlantic',
  WestSouthCentral = 'WestSouthCentral',
}

export type User = {
  __typename?: 'User';
  adGroups?: Maybe<Array<Scalars['String']['output']>>;
  bookmarks?: Maybe<Array<Bookmark>>;
  /** Explicit care-entity value used for the CARE_ENTITY segment of this user's ingestion filenames. Null means "use tenant.code", which is the case for very nearly every user. */
  careEntityCode?: Maybe<Scalars['String']['output']>;
  ccOnboardingEmail?: Maybe<Scalars['String']['output']>;
  clientDataFiles?: Maybe<ClientDataFile>;
  /** Creation Datetime */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Additional details about the user account */
  description?: Maybe<Scalars['String']['output']>;
  disableBiomedataLogin: Scalars['Boolean']['output'];
  distributionLists?: Maybe<Array<DistributionList>>;
  email: Scalars['String']['output'];
  enableSftp: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Time when the user was enabled. This is used to keep certain items on the UI disabled until this change is synced to Azure AD. */
  enabledTime?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<FileDistributionList>>;
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  homepage?: Maybe<Bookmark>;
  /** Auto increment ID */
  id: Scalars['ID']['output'];
  identityStore?: Maybe<Scalars['String']['output']>;
  initialPasswordResetDate?: Maybe<Scalars['DateTime']['output']>;
  jobs?: Maybe<Array<Job>>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  logins?: Maybe<Array<UserLogin>>;
  notificationLogs?: Maybe<Array<NotificationLogs>>;
  notifications?: Maybe<Array<Notification>>;
  organizationalUnit?: Maybe<Scalars['String']['output']>;
  otherEmails?: Maybe<Array<OtherEmail>>;
  passwordNeverExpires: Scalars['Boolean']['output'];
  permanentAccount: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  recentTableauViews?: Maybe<Array<RecentTableauView>>;
  roles?: Maybe<Array<Role>>;
  root: Scalars['Boolean']['output'];
  sponsoredTenants?: Maybe<Array<Tenant>>;
  /** Tracks the status of user account activation */
  status?: Maybe<UserStatus>;
  submissions?: Maybe<Array<Submission>>;
  submitsData: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Array<Token>>;
  twoFactor?: Maybe<Scalars['Boolean']['output']>;
  /** Modification Datetime */
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  userLastLogin?: Maybe<UserLastLogin>;
  /** Unique username */
  username: Scalars['String']['output'];
};

export type UserAudit = {
  __typename?: 'UserAudit';
  accessModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  allowedCareEntityDsms: Array<CareEntityDsmPair>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataRefreshEmailsEnabled: Scalars['Boolean']['output'];
  distributionLists: Array<UserAuditDistributionList>;
  echoSummaryEmailsEnabled: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  lastLoginDate?: Maybe<Scalars['DateTime']['output']>;
  lastRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
  riskAuditEmailsEnabled: Scalars['Boolean']['output'];
  roles: Array<UserAuditRole>;
  submitsData: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type UserAuditDistributionList = {
  __typename?: 'UserAuditDistributionList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserAuditRole = {
  __typename?: 'UserAuditRole';
  careEntityIds: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  dsmIds: Array<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: RoleType;
};

export type UserLastLogin = {
  __typename?: 'UserLastLogin';
  lastLoginDate: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserLogin = {
  __typename?: 'UserLogin';
  /** Auto Generated ID */
  id: Scalars['ID']['output'];
  identityProvider: IdentityProvider;
  ipAddress: Scalars['String']['output'];
  loginDate: Scalars['DateTime']['output'];
  user: User;
  userAgent: Scalars['String']['output'];
};

export type UserPolicyInput = {
  action: Scalars['String']['input'];
  attribute: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  eft?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  /** roles/<roleId> */
  subjectId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export enum UserStatus {
  Activated = 'ACTIVATED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
}

export enum ValidationStatus {
  Error = 'Error',
  Failed = 'Failed',
  InProgress = 'InProgress',
  ManualOverride = 'ManualOverride',
  Pending = 'Pending',
  Success = 'Success',
}

export enum VisibilityType {
  Default = 'DEFAULT',
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE',
}

export type Workbook = {
  __typename?: 'Workbook';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModule?: Maybe<DiseaseStateModule>;
  diseaseStateModuleId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  measureIds?: Maybe<Array<Scalars['Int']['output']>>;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  /** Legacy Tableau contentUrl of the workbook, e.g. Cath-FaceSheet in .../views/Cath-FaceSheet/OEBleedingEvents */
  tableauUri: Scalars['String']['output'];
  tableauViews?: Maybe<Array<TableauView>>;
  tags?: Maybe<Array<Tags>>;
  tenants?: Maybe<Array<Tenant>>;
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  workbookGroup?: Maybe<WorkbookGroup>;
  workbookGroupId?: Maybe<Scalars['Int']['output']>;
};

export type WorkbookGroup = {
  __typename?: 'WorkbookGroup';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdById: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diseaseStateModule: DiseaseStateModule;
  diseaseStateModuleId: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  renderAsLink: Scalars['Boolean']['output'];
  renderInMenu: Scalars['Boolean']['output'];
  sortOrder: Scalars['Float']['output'];
  updateAt: Scalars['DateTime']['output'];
  updateBy?: Maybe<User>;
  updateById: Scalars['String']['output'];
  workbooks?: Maybe<Array<Workbook>>;
};
